if (document.location.href.indexOf("vd-slider-disable") == -1) {
    ! function() {
        "use strict";
        const t = t => {
                try {
                    t()
                } catch (t) {
                    o(t)
                }
            },
            i = i => function(...s) {
                return t(() => i.apply(this, s))
            },
            s = t => {
                o(t)
            },
            e = (t, s, e, r) => {
                const o = i(e);
                return t.addEventListener(s, o, r), o
            },
            r = (t, s, ...e) => window.setTimeout(i(t), s, ...e);

        function o(t) {
            if (function(t) {
                    const i = t && t.message || "";
                    if ([/network\s*error/i, /failed to fetch/i, /load failed/i].some(t => t.test(i))) return !0;
                    if (window.Sentry) return !0;
                    if (!window.vdSliderInstallConfig) return !0;
                    return !1
                }(t)) throw t;
            window.sentryOnLoad = function() {
                Sentry.init({
                    defaultIntegrations: !1,
                    integrations: [],
                    replaysSessionSampleRate: 0,
                    replaysOnErrorSampleRate: 0
                }), Sentry.captureException(t, {
                    extra: {
                        url: window.location.href,
                        shop: Shopify.shop
                    },
                    user: {
                        username: Shopify.shop
                    }
                }), Sentry.close(2e3)
            };
            var i = document.createElement("script");
            i.src = "https://js.sentry-cdn.com/4babeb32ea1273e301ba1129741b6134.min.js", i.setAttribute("crossorigin", "anonymous"), i.setAttribute("data-lazy", "no"), document.head.appendChild(i)
        }
        const d = /^(.*)(\.[^\.]+)$/,
            n = Array.from({
                length: 15
            }, (t, i) => 180 * (i + 1));
        class l {
            constructor(t, i) {
                this.t = t, this.i = i, this.s = t.match(d)
            }
            o(t) {
                return this.i.i_sb_b ? this.i.i_sb_b(t, this) : this.s ? this.s[1] + "_" + t + "x" + this.s[2] : this.t
            }
            l(t) {
                var i = [];
                return (t = t || n).forEach(t => {
                    i.push(this.o(t) + " " + t + "w")
                }), i.join(", ")
            }
            p(t) {
                return n.find(i => {
                    if (i >= t) return i
                }) || t
            }
        }

        function a(t, i, s, e = "div") {
            var r = document.createElement(e);
            for (var o in r.className = t, Array.isArray(i) || (i = [i]), i.forEach(t => {
                    t && ("string" == typeof t ? r.innerHTML = t : r.appendChild(t))
                }), s = s || {}) r.setAttribute(o, s[o]);
            return r
        }

        function p(t, i) {
            return i ? function(t, i) {
                return a("vd-slider-button-with-text", [a("vd-slider-svg", t), a("vd-slider-text", i)])
            }(t, i) : a("vd-slider-button", t)
        }
        var h = {
            u: a,
            _: {
                g: (t, i) => p(i.i_hu_bs || '<svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5" /><path d="M12 12l8 -4.5" /><path d="M12 12l0 9" /><path d="M12 12l-8 -4.5" /></svg>', t),
                k: (t, i) => p('<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M7 4v16l13 -8z" fill="currentColor"></path></svg>', t)
            },
            S: function(t, i, s = {}) {
                var e = document.createElement("script");
                for (var r in i && (e.onload = i), e.src = t, s) e.setAttribute(r, s[r]);
                document.head.appendChild(e)
            },
            M: function(t) {
                var i = document.createElement("link");
                i.href = t, i.setAttribute("rel", "stylesheet"), document.head.appendChild(i)
            },
            I: function(t, i, s, r) {
                r ? (t.setAttribute("pmimg-loaded", !0), t.setAttribute("loading", "eager"), t.setAttribute("fetchPriority", "high"), t.setAttribute("decoding", "sync")) : (e(t, "load", () => t.setAttribute("pmimg-loaded", !0)), t.setAttribute("loading", "lazy"), t.setAttribute("fetchPriority", "low"), t.setAttribute("decoding", "async")), t.C && (t.setAttribute("pmimg-loaded", !0), t.setAttribute("style", "background-color: transparent; background-image: url(" + t.C + ");")), t.onload = () => {
                    t.setAttribute("pmimg-src-loaded", !0)
                }, t.j && i && t.clientWidth * window.devicePixelRatio <= t.j ? i && t.setAttribute("src", t.C) : (s && t.setAttribute("srcset", s), i && t.setAttribute("src", i))
            },
            A: function(t, i) {
                var s = a("vd-slider-fs-ar--content", t, {
                    style: "aspect-ratio: " + i + ";"
                });
                return a("vd-slider-fs-ar", s)
            }
        };
        class m {
            constructor(t, i, s) {
                this.L = t, this.H = t.V, this.B = t.B, this.i = i, this.R = s, this.D = document.createElement("img"), this.D.setAttribute("style", "aspect-ratio: " + this.B), this.D.C = t.C, this.D.j = t.j, t.T && "" != t.T && this.D.setAttribute("alt", t.T), this.N = h.u("vd-slider-slide--inner", this.D), this.O = h.u("vd-slider-slide", this.N), this.P = new l(this.H, this.i), this.X = !1
            }
            F(t) {
                if (!this.X) {
                    var i = this.Z();
                    h.I(this.D, this.P.o(i), this.P.l(), this.R), this.O.className += " vd-slider-slide--loaded", this.X = !0, t && t()
                }
            }
            G() {
                this.Z()
            }
            Z() {
                var t = this.O.clientWidth,
                    i = parseInt(this.D.getAttribute("sizes") || 0),
                    s = Math.max(t || 0, i, 360);
                return (0 == i || s > i) && this.D.setAttribute("sizes", s + "px"), s
            }
            W() {
                -1 != this.D.src.indexOf(".gif") && (this.D.src = this.D.getAttribute("src"))
            }
        }
        class c {
            constructor(t, i, s) {
                this.L = t, this.q = i, this.J = new m(t, i.i, s), this.O = this.J.O, this.R = s
            }
            F() {
                this.J.F(() => {
                    if (e(this.O, "click", () => {
                            this.q.Y(this)
                        }), this.$()) {
                        var t = this.q.K;
                        e(this.O, "mouseleave", () => t.U()), e(this.O, "mousemove", i => {
                            window.ppzoom && window.vdSliderTouchDetected || t.tt(this, i)
                        })
                    }
                })
            }
            G() {
                this.J.G(), r(() => this.it(), this.R ? 2e3 : 500)
            }
            W() {
                this.J.W()
            }
            st() {
                return {
                    src: this.L.H,
                    w: this.L.et,
                    h: this.L.rt,
                    i_bt: t => this.q.lt.nt.ot(t, this.L),
                    i_cpi: () => {
                        try {
                            return this.J.D.currentSrc
                        } catch (t) {
                            return null
                        }
                    }
                }
            }
            $() {
                return this.q.K && "image" == this.L.pt && -1 == this.L.H.indexOf(".gif")
            }
            it() {
                this.$() && window.screen.width > 800 && this.q.K.ht(this)
            }
        }

        function u(t, i = !1, s = {}) {
            return {
                ct: function(r, o = {}) {
                    var d, n = s.i_m_hhh,
                        [l, a, p, h] = function(t, i, s, r) {
                            var o = document.createElement("div");
                            o.className = "vd-slider-modal", t && (o.className += " vd-slider-modal--" + t);
                            var d = document.createElement("span");
                            d.className = "vd-slider-modal--close", d.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"/></svg>';
                            var n = document.createElement("div");
                            n.setAttribute("role", "dialog"), n.className = "vd-slider-modal--dialog";
                            var l = document.createElement("div");
                            l.className = "vd-slider-modal--header";
                            var a = document.createElement("div");
                            a.className = "vd-slider-modal--content";
                            var p = document.createElement("div");
                            p.className = "vd-slider-modal--actions", e(p, "click", (function(t) {
                                t.stopPropagation()
                            }));
                            var h = document.createElement("div");

                            function m(t) {
                                t && (t.stopPropagation(), t.preventDefault()), s && !1 === s(t) || (r && r(), o.className = o.className.replace(" is-open", ""), document.body.className = document.body.className.replace(" vd-slider-modal-open", ""), a.innerHTML = "", p && (p.innerHTML = ""), !i && o.parentNode && o.parentNode.removeChild(o))
                            }
                            return h.className = "vd-slider-modal--overlay", o.appendChild(h), document.body.appendChild(o), o.appendChild(n), o.appendChild(d), n.appendChild(l), n.appendChild(a), n.appendChild(p), e(o, "click", (function(t) {
                                "MODEL-VIEWER" !== t.target.tagName && m(t)
                            })), e(d, "click", m), e(h, "click", m), [o, a, p, m]
                        }(t, i, (function() {
                            return n && window.location.hash === "#" + n ? (window.history.back(), !1) : (d && window.removeEventListener("popstate", d), !0)
                        }), o.ut);
                    n && (window.location.hash = n, d = function() {
                        window.location.hash !== "#" + n && h()
                    }, window.addEventListener("popstate", d)), l.classList.add("is-open"), document.body.classList.add("vd-slider-modal-open"), a.innerHTML = "", a.appendChild(r), o.wt && o.wt({
                        O: l,
                        _t: a,
                        ft: p
                    })
                }
            }
        }

        function w(t, i, s) {
            var e = document.createElement("video");
            if (i.i_nv_fbs) var r = i.i_nv_fbs(t.bt);
            else r = function(t) {
                var i = t.filter(t => -1 != t.mime_type.indexOf("video")).sort((t, i) => t.width - i.width);
                if (window.innerWidth < 768)
                    for (var s = 0; s < i.length; s++)
                        if (i[s].width >= window.innerWidth * window.devicePixelRatio) return [i[s]];
                return [i[i.length - 1]]
            }(t.bt);
            return r.forEach(t => {
                var i = document.createElement("source");
                i.type = t.mime_type, i.src = t.url, e.appendChild(i)
            }), i.i_ism_dnlv || e.setAttribute("loop", !0), e.setAttribute("preload", "none"), e.setAttribute("controls", !0), e.setAttribute("playsinline", !0), e.setAttribute("poster", t.V), s && (e.setAttribute("autoplay", !0), e.setAttribute("muted", !0)), {
                O: e,
                gt: function() {
                    e.pause()
                },
                k: function() {
                    try {
                        e.play()
                    } catch (t) {}
                },
                vt: function() {
                    return e.paused
                }
            }
        }
        class _ {
            constructor(t, i, s) {
                this.L = t, this.q = i, this.i = i.i, this.yt = s, this.J = this.xt(), this.O = this.J.O
            }
            xt() {
                return f(this.L, this.i, this.yt)
            }
            F() {
                this.J.F()
            }
            G(t) {
                this.J.G(t)
            }
            W() {
                this.J.W()
            }
            kt() {
                this.J.kt && this.J.kt(), this.zt && this.zt.kt()
            }
            St(t) {
                this.J.St(t)
            }
            st() {
                if (this.F(), !this.Mt) {
                    this.zt = this.xt(), this.zt.F();
                    var t = h.A(this.zt.N, this.L.B);
                    this.Mt = {
                        html: h.u("vd-slider-center", t),
                        It: () => {
                            r(this.zt.W, 100)
                        },
                        Ct: t => {
                            t || this.zt.G()
                        },
                        i_bt: t => this.q.lt.nt.ot(t, this.L)
                    }
                }
                return this.Mt
            }
        }

        function f(t, i, s) {
            var e, o, d, n, l, a, p, m, c, u;

            function _(t) {
                m = t,
                    function(t) {
                        if (!p) return;
                        let i = o.parentElement ? o.parentElement.clientWidth / o.parentElement.clientHeight : 1;
                        o.setAttribute("data-portrait", i < t)
                    }(t)
            }
            return o = h.u("vd-slider-slide--inner"), e = h.u("vd-slider-slide", o), l = !!navigator.userAgent.match(/iPhone/i), a = "video" == t.pt, p = !a && -1 != t.H.indexOf("vimeo"), c = !0, i.i_sp_dpi && (c = !1), _(t.B), r((function() {
                v()
            }), 500), {
                O: e,
                N: o,
                B: m,
                W: function() {
                    u = !1, n && (n.pause(), n.autoplay = !1, d.setAttribute("autoplay", !1), d.setAttribute("inert", "true"))
                },
                kt: function() {
                    n && n.pause()
                },
                G: function(t) {
                    d && d.removeAttribute("inert"), t || (u = !0, c && function t(i) {
                        if (n && (u ? n.play() : n.pause()), i[0]) {
                            var s = i.shift();
                            r((function() {
                                t(i)
                            }), s)
                        }
                    }([200, 200, 200, 300, 300]))
                },
                F: function(r) {
                    this.X = !0, v((function() {
                        if (!d) {
                            d = "video" == t.pt ? w(t, i, s).O : h.u("plyr__video-embed", function(t) {
                                var i = document.createElement("iframe");
                                if (-1 != t.H.indexOf("youtube")) var s = "?loop=true&amp;byline=false&amp;portrait=false&amp;playsinline=1&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media";
                                else s = "?iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1";
                                return i.src = t.H + s, i.setAttribute("frameborder", 0), i.setAttribute("allow", "autoplay; fullscreen"), i.setAttribute("allowfullscreen", ""), {
                                    O: i
                                }
                            }(t).O, {
                                inert: "true"
                            }), o.appendChild(d);
                            let r = function() {
                                let e = l || i.i_sp_m;
                                var r = {
                                    debug: !1,
                                    playsinline: c,
                                    muted: e,
                                    youtube: {
                                        noCookie: !0,
                                        rel: 0,
                                        showinfo: 0,
                                        iv_load_policy: 3,
                                        modestbranding: 1,
                                        playsinline: 1
                                    },
                                    controls: ["play-large", "play", "progress", "current-time", "mute", "volume"]
                                };
                                return s && (r.autoplay = !0), i.i_sp_oo && (r = Object.assign(r, i.i_sp_oo)), l || r.controls.push("fullscreen"), i.i_sp_bo && (r = i.i_sp_bo(r, t)), r
                            }();
                            (function(t, i) {
                                i.autoplay && (t.autoplay = !0);
                                i.muted && (t.muted = !0);
                                i.volume && (t.volume = i.volume)
                            })(n = new Plyr(d, r), r), n.on("playing", () => {
                                _(function() {
                                    var t = n.ratio;
                                    if (t) {
                                        var i = t.split(":");
                                        return 2 == i.length ? parseFloat(i[0]) / parseFloat(i[1]) : parseFloat(t)
                                    }
                                }())
                            }), e.className += " vd-slider-slide--loaded"
                        }
                        r && r()
                    }))
                },
                St: function(t) {
                    n && (t || n.pause())
                }
            }
        }
        var b = !1,
            g = [];

        function v(t) {
            window.Plyr ? t && t() : (t && g.push(t), b || (b = !0, h.S("https://cdn.plyr.io/3.7.8/plyr.js", (function() {
                g.forEach(t => t()), g = []
            })), h.M("https://cdn.plyr.io/3.7.8/plyr.css")))
        }

        function y(t, i) {
            var s, r, o = u("", !1, i);
            return {
                ct: function() {
                    s || (s = f(t, i), r = h.A(s.N, t.B), e(r, "click", (function(t) {
                        t.stopPropagation()
                    }))), s.F(), o.ct(r, {
                        ut: function() {
                            s.W()
                        }
                    }), s.G()
                }
            }
        }
        class x {
            constructor(t, i) {
                this.L = t, this.H = t.V, this.B = t.B, this.i = i, this.N = h.u("vd-slider-slide--inner vd-slider-preview-autoplay"), this.O = h.u("vd-slider-slide", this.N), this.X = !1
            }
            F(t) {
                this.X || (this.jt = w(this.L, this.i), this.At = this.jt.O, this.At.setAttribute("muted", !0), this.At.muted = !0, this.At.removeAttribute("controls"), this.At.load(), this.N.appendChild(this.At), this.O.className += " vd-slider-slide--loaded", this.X = !0, t && t())
            }
            G() {
                this.F(), this.jt.k()
            }
            W() {
                this.jt.gt()
            }
            Lt() {
                this.jt.vt() ? this.jt.k() : this.jt.gt()
            }
        }
        class k {
            constructor(t, i) {
                this.L = t, this.i = i.i, this.q = i, this.Ht = "video" == t.pt && 1 == this.i.i_sp_vpi, this.Vt = "video" == t.pt && 1 == this.i.i_sp_vpiz, this.J = this.xt(this.Ht), this.O = this.J.O
            }
            xt(t) {
                if (t) var i = new x(this.L, this.i);
                else i = new m(this.L, this.i);
                return i.N.appendChild(h._.k()), i
            }
            F() {
                this.J.F(() => {
                    this.O.className = this.O.className + " vd-slider-slide--preview", this.Bt = y(this.L, this.i), e(this.O, "click", () => {
                        this.Rt()
                    })
                })
            }
            G() {
                this.J.G()
            }
            W() {
                this.J.W()
            }
            Rt() {
                this.F(), this.Vt && window.ppzoom ? (this.q.Y(this), this.zt.G()) : this.Bt.ct()
            }
            st() {
                if (this.F(), !this.Mt) {
                    this.zt = this.xt(this.Vt), this.zt.F();
                    var t = h.A(this.zt.N, this.L.B);
                    e(t, "click", () => {
                        this.Rt()
                    }), this.Mt = {
                        html: h.u("vd-slider-center", t),
                        It: () => {
                            this.zt.W()
                        },
                        Ct: () => {
                            this.zt.G()
                        },
                        i_bt: t => this.q.lt.nt.ot(t, this.L)
                    }
                }
                return this.Mt
            }
        }
        class z {
            constructor(t, i, {
                Dt: s = !1,
                Tt: e,
                Nt: r
            } = {}) {
                this.Ot = t, this.i = i, this.Tt = e, this.Dt = s, this.Nt = r, this.O = h.u("vd-slider-model-viewer"), this.O.setAttribute("data-inline", this.Dt), this.Pt()
            }
            Et() {
                this.Xt.setAttribute("src", ""), this.Xt.setAttribute("src", this.Ot)
            }
            Pt() {
                if (!this.Xt) {
                    if (this.Ft(), !this.Dt) {
                        let t = h._.g(null, this.i);
                        e(t, "click", this.Zt.bind(this)), this.O.appendChild(t)
                    }
                    this.Xt = document.createElement("model-viewer"), this.Gt = new u("white", !1, this.i);
                    var t = {
                        "auto-rotate": "",
                        "shadow-intensity": "1"
                    };
                    for (var i in this.Dt ? (t["camera-controls"] = "", t["ar-modes"] = "webxr scene-viewer quick-look", t.ar = "") : (this.Nt || e(this.Xt, "click", this.Zt.bind(this)), t.poster = this.Tt), this.Et(), t) this.Xt.setAttribute(i, t[i]);
                    this.i.i_mv_amv && (this.Xt = this.i.exec("i_mv_amv", this.Xt)), this.O.appendChild(this.Xt)
                }
            }
            Zt() {
                let t;
                this.Wt || (this.Wt = new z(this.Ot, this.i, {
                    Dt: !0
                })), this.Wt.Et(), this.i.get("i_mv_omo") && (t = {
                    wt: t => {
                        this.i.exec("i_mv_omo", Object.assign({
                            qt: this
                        }, t))
                    }
                }), this.Gt.ct(this.Wt.O, t)
            }
            Ft() {
                window.vdSliderMVI || (h.S("https://ajax.googleapis.com/ajax/libs/model-viewer/3.1.1/model-viewer.min.js", !1, {
                    type: "module"
                }), window.vdSliderMVI = !0)
            }
        }
        class S {
            constructor(t, i) {
                this.L = t, this.q = i, this.B = t.B, this.J = new M(this.Jt(), i.i, t), this.O = this.J.O
            }
            F() {}
            G(t) {
                t || this.J.G()
            }
            W() {
                this.J.W()
            }
            st() {
                if (!this.Yt) {
                    let t = this.Jt(!0);
                    this.Yt = {
                        html: h.u("vd-slider-center", t.O),
                        It: () => {},
                        Ct: () => {
                            t.Et()
                        },
                        i_bt: t => this.q.lt.nt.ot(t, this.L)
                    }
                }
                return this.Yt
            }
            Jt(t) {
                let i = this.L.bt.find(t => t.url.indexOf(".glb") > 0).url;
                return new z(i, this.q.i, {
                    Tt: this.L.V,
                    Nt: t
                })
            }
        }
        class M {
            constructor(t, i, s) {
                this.$t = t, this.i = i, this.B = s.B, this.O = h.u("vd-slider-slide vd-slider-slide--loaded", this.N = h.u("vd-slider-slide--inner", t.O))
            }
            F() {}
            G() {
                this.$t.Et()
            }
            W() {}
        }
        class I {
            constructor(t, i) {
                this.i = t, this.q = i, this.Kt = !1, this.O = !1, this.Ut = new C, this.Qt = !1, this.ti = null, this.ii = t.i_hz_zf || 2, this.si = t.i_hz_scf || 1,
                    function(t) {
                        let i = document.getElementById("hzafi");
                        i || (i = document.createElement("style"), i.id = "hzafi", document.head.appendChild(i));
                        const s = [`@keyframes vd-slider-hzafi { from { opacity: 0; background-size: 100%; box-shadow: 0px 0px 20px -5px #00000000;  } 45% { opacity: 0 } 50% { opacity: 0.9; background-size: 100%; } 50% { opacity: 1 } to { opacity: 1; background-size: ${t}00%; } }`];
                        i.innerHTML = s.join("\n")
                    }(this.ii)
            }
            ht(t) {}
            tt(t, i) {
                if (this.Kt != t && (this.U(), this.Kt = t), window.vdSliderTouchDetected && this.O) this.U();
                else {
                    this.ei(t);
                    var s = this.ri(),
                        e = i.clientX - s.left,
                        r = i.clientY - s.top,
                        o = this.oi(e, s.width),
                        d = this.oi(r, s.height);
                    j(this.O, "background-position", o + "% " + d + "%"), this.ti && !this.di() && this.Ut.ni(e, r, s, this.ti.getBoundingClientRect(), this.ii)
                }
            }
            ri() {
                return this.q.ai.li.getBoundingClientRect()
            }
            oi(t, i) {
                if (this.di()) return t / i * 100;
                var s = this.ii,
                    e = t / i;
                if (e = Math.min(Math.max(e, 0), 1), s <= 1) return 100 * e;
                var r = s - 1,
                    o = e * s - .5;
                return o = Math.min(Math.max(o, 0), r), 0 === r ? 100 * e : o / r * 100
            }
            di() {
                return this.ti === this.pi()
            }
            pi() {
                return this.Kt.O
            }
            U() {
                this.O && (this.O.parentNode && this.O.parentNode.removeChild(this.O), this.O = !1), this.ti = null, this.hi(), this.Ut.U()
            }
            ei(t) {
                if (this.O) return;
                this.O = h.u("vd-slider-slide--hover-zoom");
                let i = this.mi(t),
                    s = new Image;
                s.onload = () => {
                    t.O.matches(":hover") ? (j(this.O, "background-image", 'url("' + i + '")'), j(this.O, "background-size", this.ii + "00%"), j(this.O, "animation", "vd-slider-hzafi .5s"), this.ti = this.ci(), this.ui(this.ti)) : this.U()
                }, s.src = i
            }
            mi(t) {
                var i = t.J.P.o(Math.floor(t.O.clientWidth * this.ii * this.si));
                return this.i.i_hz_bns && (i = this.i.i_hz_bns(t, i, this)), i
            }
            ci() {
                let t = this.ri();
                return !0 === this.i.i_hz_asm && this.wi(t) ? this._i(t) : this.pi()
            }
            wi(t) {
                return (document.documentElement && document.documentElement.clientWidth || 0) - t.right > t.width * this.si
            }
            _i(t) {
                return this.Qt || (this.Qt = h.u("vd-slider-hover-zoom-side")), j(this.Qt, "position", "absolute"), j(this.Qt, "width", t.width * this.si + "px"), j(this.Qt, "height", t.width * this.si + "px"), j(this.Qt, "top", t.top + window.scrollY + "px"), j(this.Qt, "left", t.right + window.scrollX + "px"), j(this.Qt, "zIndex", "10"), j(this.Qt, "pointerEvents", "none"), this.Qt.parentNode || document.body.appendChild(this.Qt), this.Qt.setAttribute("data-visible", "true"), this.Qt
            }
            hi() {
                this.Qt && this.Qt.setAttribute("data-visible", "false")
            }
            ui(t) {
                this.O.parentNode !== t && (this.O.parentNode && this.O.parentNode.removeChild(this.O), t.appendChild(this.O))
            }
        }
        class C {
            constructor() {
                this.O = h.u("vd-slider-hover-zoom-lens")
            }
            U() {
                this.O.parentNode && this.O.parentNode.removeChild(this.O)
            }
            ni(t, i, s, e, r) {
                this.O.parentNode || document.body.appendChild(this.O);
                var o = s.width || 0,
                    d = s.height || 0,
                    n = o / r,
                    l = n,
                    a = Math.max(o - n, 0),
                    p = Math.max(d - l, 0),
                    h = Math.min(Math.max(t - n / 2, 0), a),
                    m = Math.min(Math.max(i - l / 2, 0), p),
                    c = window.scrollX || 0,
                    u = window.scrollY || 0,
                    w = s.left + c + h,
                    _ = s.top + u + m;
                j(this.O, "width", n + "px"), j(this.O, "height", l + "px"), j(this.O, "transform", "translate(" + w + "px, " + _ + "px)")
            }
        }

        function j(t, i, s) {
            t.style.setProperty(i, s)
        }
        var A, L = CSS.supports && CSS.supports("aspect-ratio: 1");
        class H {
            constructor(t, i) {
                this.ai = t, this.fi = t.fi, this.li = t.li, this.lt = i, this.i = i.i, this.bi = {}, "1" == this.i.ezh && (this.lt.nt.gi || this.lt.nt.vi) && (this.K = new I(this.i, this))
            }
            yi() {
                var t, i, s = this.xi[this.lt.ki].J.B,
                    e = this.i.ar;
                switch (e) {
                    case "fw":
                        i = " vd-slider-root--ar-fw";
                        var r = function(t) {
                                var i = t[0].J.B;
                                for (let s = 0; s < t.length; s++) {
                                    const e = t[s];
                                    i = Math.max(i, e.J.B)
                                }
                                return i
                            }(this.xi),
                            o = this.li.clientWidth / r;
                        (r - s) / s <= .05 && (o *= .95), this.ai.zi.style = "max-height: " + Math.max(o, 300) + "px;", this.Si = !0;
                        break;
                    case "fss":
                        i = " vd-slider-root--ar-fit-s", t = 1.2 * s;
                        break;
                    default:
                        var d = parseInt(e);
                        d == e && d > 0 ? (i = " vd-slider-root--ar-fix vd-slider-root--ar-fit", t = parseInt(e) / 100, this.Mi = t) : (i = " vd-slider-root--ar-fit", t = s, this.Mi = t)
                }
                this.ai.Ii.className += i, this.i.i_ism_dar && (t = this.i.i_ism_dar(this.xi, t, this)), t && (this.Ci = t, this.li.style = "padding-top: " + 100 / t + "%;", this.ai.Ii.style = "--vd-slider-ar: " + t), this.ji(), this.Si && this.fi.scrollWidth > 0 && this.fi.scrollWidth <= this.li.clientWidth && (this.ai.Ii.className += " vd-slider-root--fits")
            }
            ji() {
                this.xi.forEach(t => {
                    if (this.Mi) var i = this.Mi;
                    else {
                        i = t.J.B;
                        if (this.Ci) Math.abs(this.Ci - i) / this.Ci < .1 && (i = this.Ci)
                    }
                    if (L) t.O.setAttribute("style", "aspect-ratio: " + i);
                    else {
                        var s = this.ai.li.clientHeight * i * 1.02;
                        t.J.N.setAttribute("style", "width: " + s + "px;")
                    }
                })
            }
            Ai(t, i, s) {
                var e = this.i.pvi || this.i.i_ism_up;
                switch (t.pt) {
                    case "image":
                        return new c(t, this, !0);
                    case "model":
                        return new S(t, this);
                    default:
                        if (e) {
                            return new _(t, this, i == s)
                        }
                        return new k(t, this)
                }
            }
            Li(t, i) {
                if (!this.Hi()) {
                    this.xi = [];
                    for (let r = 0; r < t.length; r++) {
                        var s = t[r];
                        if (this.i.i_ism_bsn) var e = this.i.i_ism_bsn(s, this);
                        else e = this.Ai(s, r, i);
                        this.xi.push(e), this.fi.appendChild(e.O)
                    }
                    this.yi()
                }
            }
            Vi() {
                this.Hi() && (this.Bi(this.lt.ki), this.ai.Ii.querySelectorAll(".vd-slider-slide").forEach(t => {
                    t.parentNode && t.parentNode.removeChild(t)
                }), this.xi = [])
            }
            Hi() {
                return !!this.xi
            }
            Bi(t, i) {
                var s = !!i && i.hidden,
                    e = this.xi[t];
                e.F(), e.O.setAttribute("data-vd-slider-slide-active", !0), e.G(s), this.Ri(e, t), r(() => {
                    this.Di(t, e)
                }, this.Ti || this.Si ? 300 : 1e3), this.Ti = !0
            }
            Ri(t, i) {
                if (!this.i.i_tm_fi) {
                    var s = this.fi.scrollWidth - this.li.clientWidth,
                        e = 0;
                    0 == i ? e = 0 : i == this.xi.length - 1 ? e = s : (e = t.O.offsetLeft, this.i.i_ism_atlons || (e -= Math.floor((this.li.clientWidth - t.O.clientWidth) / 2))), this.fi.setAttribute("style", "transform: translateX(" + -e + "px)")
                }
            }
            Ni(t) {
                this.Kt && this.Kt.O.removeAttribute("data-vd-slider-slide-previous"), this.Kt = t, t.O.setAttribute("data-vd-slider-slide-previous", !0)
            }
            Oi(t) {
                var i = this.xi[t];
                i.W(), i.O.removeAttribute("data-vd-slider-slide-active"), this.Ni(i)
            }
            Di(t, i) {
                var s = this.ai.li.clientWidth;
                ! function(t, i, [s, e], r) {
                    s || (s = i.length);
                    e || (e = i.length);
                    let o = new Set;
                    for (let s = t + 1; s < t + e + 1; s++) s >= 0 && s < i.length && o.add(s);
                    for (let e = t - 1; e > t - s - 1; e--) e >= 0 && e < i.length && o.add(e);
                    o.forEach(r)
                }(t, this.xi, [1, 4], t => {
                    let e = this.xi[t];
                    var o, d, n, l, a, p;
                    e.J.X || (o = e.O, d = i.O, n = s, l = d.offsetLeft + d.clientWidth / 2, a = l - n, p = l + n, V(o.offsetLeft + o.clientWidth, a, p) || V(o.offsetLeft, a, p) ? e.F() : r(() => {
                        e.F()
                    }, 100))
                })
            }
            Pi() {
                var t = [];
                return this.xi.forEach(i => {
                    let s = i.st();
                    s && t.push(s)
                }), t
            }
            Y(t) {
                if (this.lt.nt.Ei && window.ppzoom) {
                    var i = this.xi.indexOf(t),
                        s = this.Pi();
                    window.ppzoom.open(s, {
                        index: i,
                        onChange: t => {
                            var e = s[i],
                                r = s[t];
                            e.It && e.It(), r.Ct && r.Ct(), this.lt.Xi(t, {
                                hidden: !0
                            }), i = t
                        },
                        onClose: t => {
                            var i = s[t];
                            i.It && i.It()
                        },
                        bounds: t.O.getBoundingClientRect(),
                        z_o: this.i.z_o,
                        z_mg: this.i.z_mg,
                        z_mg_o: {
                            i_ba: this.lt.nt.Fi.bind(this.lt.nt)
                        },
                        rtl: this.lt.Zi
                    })
                }
            }
            Gi() {
                this.K && this.K.U()
            }
        }

        function V(t, i, s) {
            return i <= t && t <= s
        }

        function B(t) {
            t && (t.stopImmediatePropagation(), t.preventDefault())
        }

        function R(t, i) {
            if (t.touches) var s = t.touches[0].clientX,
                e = t.touches[0].clientY;
            else s = t.clientX, e = t.clientY;
            return s >= i.left && s <= i.right && e <= i.bottom && e >= i.top
        }
        class D {
            constructor(t, i) {
                this.ai = t, this.lt = i, this.Wi = [], this.qi = window.innerWidth, this.Li()
            }
            Ji(t, i, s, r) {
                const o = e(t, i, s, r);
                this.Wi.push([t, i, o, r])
            }
            Li() {
                this.Wi.lenght > 0 || (this.Ji(this.ai.zi, "mousemove", this.Yi.bind(this)), this.Ji(this.ai.zi, "mouseleave", this.Yi.bind(this)), this.lt.i.i_em_smmeb || (this.Ji(this.ai.Ii, "mouseout", B), this.Ji(this.ai.Ii, "mousein", B), this.Ji(this.ai.Ii, "mouseover", B)), this.Ji(this.ai.zi, "touchstart", this.$i.bind(this)), this.Ji(this.ai.zi, "touchmove", this.$i.bind(this)), this.Ji(this.ai.zi, "touchend", this.$i.bind(this)), this.Ji(this.ai.zi, "touchcancel", this.$i.bind(this)), this.Ji(this.ai.Ii, "keydown", this.Ki.bind(this)), this.Ji(window, "vd-slider-reset", this.Ui.bind(this)), this.Ji(window, "resize", this.Qi.bind(this)), this.Ji(window, "scroll", this.ts.bind(this)))
            }
            Ui() {
                this.lt.Hi() && this.lt.es()
            }
            Qi(t) {
                (this.qi != window.innerWidth || t.detail && t.detail.force) && (this.lt.rs(), this.qi = window.innerWidth)
            }
            ts(t) {
                var i, s, e, r, o;
                this.lt.i.i_em_tv && this.lt.St((i = this.ai.Ii, s = i.getBoundingClientRect(), e = s.top, r = s.bottom, e >= -(o = (e + r) / 2) && o <= window.innerHeight))
            }
            Vi() {
                this.Wi.forEach(t => {
                    t[0].removeEventListener(t[1], t[2])
                }), this.Wi = []
            }
            Yi(t) {
                this.lt.i.i_em_smmeb || B(t), window.vdSliderTouchDetected || (this.lt.os(), this.lt.nt.ns ? this.ls(t) : this.lt.nt.as && this.ps(t))
            }
            $i(t) {
                this.lt.os(),
                    function(t, i) {
                        "INPUT" != t.target.tagName && 1 == t.touches.length && i(t.touches[0])
                    }(t, i => this.lt.nt.as ? this.hs(t, i) : this.ms(t, i))
            }
            Ki(t) {
                "ArrowLeft" != t.key && "ArrowRight" != t.key || this.lt.cs("ArrowLeft" == t.key ? -1 : 1)
            }
            us() {
                return this.ai.li.getBoundingClientRect()
            }
            ls(t) {
                if ("mouseleave" == t.type) return;
                let i = this.us();
                if (R(t, i)) {
                    let s = (i.right - i.left) / this.lt.ws.length,
                        e = t.clientX - i.left,
                        r = Math.floor(e / s);
                    this.lt.Xi(r)
                }
            }
            ps(t) {
                "mouseleave" != t.type && R(t, this.us()) ? this.lt.Xi(1) : this.lt.Xi(0)
            }
            hs(t) {
                "touchstart" == t.type ? this.lt.Xi(1) : this.lt.Xi(0)
            }
            ms(t, i) {
                if ("touchstart" == t.type) this._s = i;
                else if ("touchmove" == t.type) {
                    if (!this._s) return void(this.lt.i.i_sr_ish_is && B(t));
                    let s = i.clientX - this._s.clientX,
                        e = i.clientY - this._s.clientY;
                    if (Math.abs(e) > Math.abs(s)) {
                        if (Math.abs(s) > 30) return void(this._s = null)
                    } else this.lt.i.i_sr_ish_is && B(t);
                    if (Math.abs(s) > 30) {
                        let t = -Math.sign(s);
                        this.lt.Zi && (t = -t), this.lt.cs(t), this._s = null
                    }
                } else this._s = null
            }
        }
        class T {
            constructor(t) {
                this.nt = t, this.lt = t.lt, this.i = t.i, this.fs = t.fs, this.bs = t.bs, this.gs = t.gs
            }
            Li(t, i) {
                let s = h.u("vd-slider-arrows-wrapper");
                s.appendChild(this.vs(t, i)), t.appendChild(s)
            }
            vs(t, i) {
                var s = ["vd-slider-arrows", "vd-slider-arrows--" + this.fs];
                return s.push("vd-slider-arrows--position-" + (this.i.ap || "ms")), s.push("vd-slider-arrows-dots--type-" + this.bs), h.u(s.join(" "), this.ys(t, i))
            }
            xs(t, i) {
                var s = h.u("vd-slider-arrows_arrow");
                this.gs && (s.style.backgroundColor = this.gs), s.innerHTML = this.nt.ks(t);
                var r = t ? "Previous" : "Next",
                    o = h.u("vd-slider-arrows_area vd-slider-arrows_area-" + (t ? "left" : "right"), s, {
                        tabindex: "0",
                        "aria-label": r
                    });
                return e(o, "click", s => {
                    N(s), i(t)
                }), e(o, "keydown", s => {
                    "Enter" != s.key && " " != s.key || (N(s), i(t))
                }), o
            }
            ys(t, i) {
                var s = this.xs(!0, i),
                    e = this.xs(!1, i),
                    r = h.u("vd-slider-arrows_container");
                return r.appendChild(s), r.appendChild(e), r
            }
            zs(t, i) {
                if (this.nt.Ss()) {
                    var s = t.scrollTop > 5,
                        e = t.scrollTop + t.clientHeight < t.scrollHeight - 5;
                    i.setAttribute("can-scroll-left", s), i.setAttribute("can-scroll-right", e)
                } else {
                    var r = t.scrollLeft > 5,
                        o = t.scrollLeft + t.clientWidth < t.scrollWidth - 5;
                    i.setAttribute("can-scroll-left", r), i.setAttribute("can-scroll-right", o)
                }
            }
        }

        function N(t) {
            t && (t.stopImmediatePropagation(), t.preventDefault())
        }
        class O {
            constructor(t, i) {
                this.nt = t, this.i = i
            }
            Ms(t = !1, i) {
                let s = [],
                    e = this.Is();
                e && s.push(this.Cs(e));
                let r = this.js();
                return r >= 0 && s.push(this.As(r, i)), s
            }
            Is() {
                return this.nt.lt.ws.find(t => "model" == t.pt)
            }
            js() {
                return this.nt.lt.ws.findIndex(t => "video" == t.pt || "external" == t.pt)
            }
            Cs(t) {
                return this.Ls("model", h._.g("View in 3D", this.i), () => {
                    this.Hs(t)
                })
            }
            As(t, i) {
                let s = this.nt.lt.ws[t];
                return this.Ls("video", h._.k("Watch video", this.i), () => {
                    this.i.i_a_vfp ? this.Vs(s) : i(t)
                })
            }
            Ls(t, i, s) {
                let r = h.u("vd-slider--gallery-action", i, {
                    "data-action": t
                });
                return e(r, "click", s), r
            }
            Hs(t) {
                this.nt.lt.Bs();
                let i = t.bt.find(t => t.url.indexOf(".glb") > 0).url,
                    s = new z(i, this.i, {
                        inline: !0
                    });
                r(() => {
                    s.Zt()
                }, 200)
            }
            Vs(t) {
                this.nt.lt.Bs(), this.Bt || (this.Bt = y(t, this.i)), this.Bt.ct()
            }
        }

        function P(t) {
            var i, s = t.match(/.{2}/g),
                e = function(t) {
                    return parseInt(t, 16)
                };
            return "rgba(" + [e(s[0]), e(s[1]), e(s[2]), (i = s[3], i ? parseFloat(parseInt(parseInt(i, 16) / 255 * 1e3) / 1e3) : 100)].join(",") + ")"
        }
        class E {
            constructor(t) {
                switch (this.Rs = [], this.lt = t, this.i = t.i, this.Ds = new O(this, this.i), this.i.dbg && this.i.dbg.length > 0 && (this.Ts = P(this.i.dbg)), this.i.abg && this.i.abg.length > 0 && (this.gs = P(this.i.abg)), this.Ei = "1" == this.i.ezc, this.Ei && !window.__vdSliderZCI && (h.S(window.vdSliderZoomSrc || "https://pmslider.netlify.app/zoom.js"), window.__vdSliderZCI = !0), this.Ns = this.i.sm || "a", this.Ns) {
                    case "dc":
                        this.Os = !0;
                        break;
                    case "dh":
                        this.vi = !0;
                        break;
                    case "a":
                        this.gi = !0;
                        break;
                    case "is":
                        this.as = !0, this.Ps = 2;
                        break;
                    default:
                        this.ns = !0
                }
                switch (this.bs = this.i.dt || "thumbs", this.bs) {
                    case "stretch_full":
                        this.Es = !0;
                        break;
                    case "stretch_half":
                        this.Xs = !0;
                        break;
                    case "minimal":
                        this.Fs = !0;
                        break;
                    case "number":
                        this.Zs = !0;
                        break;
                    case "counter":
                        this.Gs = !0;
                        break;
                    case "outline":
                        this.Ws = !0;
                        break;
                    case "zoomin":
                        this.qs = !0;
                        break;
                    case "none":
                        this.Js = !0;
                        break;
                    case "thumbs":
                        this.Ys();
                        break;
                    case "2xthmb":
                        this.Ys("size-2x");
                        break;
                    case "adapthmb":
                        this.Ys("adaptive");
                    case "fillin":
                        this.$s = !0
                }
                this.fs = this.i.at || "chp", this.Ks = this.i.dl || "h", this.Us = this.i.mtd, this.Qs() || (this.Ks = "h"), this.te = new T(this), this.i.sga && (this.ie = !0)
            }
            Ys(t) {
                this.se = !0, this.ee = this.i.sta, this.bs = "thumbs", t && (this.re = t)
            }
            Li(t, i, s) {
                this.oe = " vd-slider-root--mode-" + this.Ns + " vd-slider-root--loaded vd-slider-root--dl-" + this.Ks, this.Ei && (this.oe = this.oe + " vd-slider-root--zoom-click"), "1" == this.i.haom && (this.oe = this.oe + " vd-slider-root--hide-arrows-on-mobile"), "1" == this.i.saoh && (this.oe = this.oe + " vd-slider-root--show-arrows-on-hover"), this.i.i_tm_fi && (this.oe = this.oe + " vd-slider-root--transition-fade"), this.lt.ai.Ii.className = (this.lt.ai.Ii.className || "") + this.oe, t.length > 1 && (this.Js || this.de(t), this.gi && this.ne()), this.le(), this.Bi(i, {
                    variantChanged: !!s
                })
            }
            Oi(t) {
                this.ae(t, t => {
                    this.Rs[t].classList.remove("vd-slider-dots_dot--current")
                })
            }
            Bi(t, i = {}) {
                this.ae(t, t => {
                    this.Rs[t].classList.add("vd-slider-dots_dot--current"), this.pe(t, i)
                })
            }
            ae(t, i) {
                this.Rs[0] && (this.Rs[t] || (t = this.Rs.length - 1), i(t))
            }
            Ss() {
                return "v" == this.Ks
            }
            pe(t, i = {}) {
                var s = this.Rs[t].parentNode,
                    e = s.parentNode,
                    r = !this.i.i_ui_dstte && i.variantChanged;
                if (this.Ss()) {
                    var o = s.getBoundingClientRect(),
                        d = e.getBoundingClientRect();
                    r ? e.scrollTop = s.offsetTop : o.top > d.top + 30 && o.bottom < d.bottom - 30 || (e.scrollTop = s.offsetTop - e.clientHeight / 2 + s.clientHeight / 2)
                } else {
                    var n = s.offsetLeft,
                        l = n + s.offsetWidth,
                        a = e.scrollLeft,
                        p = a + e.clientWidth;
                    r ? e.scrollLeft = n : n > a + 30 && l < p - 30 || (e.scrollLeft = n - e.clientWidth / 2 + s.offsetWidth / 2)
                }
            }
            he(t) {
                this.me = h.u("vd-slider-dots_container", null, {
                    tabindex: "-1"
                }), this.Ts && (this.me.style.backgroundColor = this.Ts);
                let i = t,
                    s = 0;
                return this.se && this.Us && t.length > this.Us && (i = t.slice(0, this.Us), s = t.length - i.length + 1), i.forEach((e, r) => {
                    let o = r == i.length - 1 && s > 0;
                    var d = h.u("vd-slider-dots_dot", null, null, "span"),
                        n = h.u("vd-slider-dots_dot-wrapper", null, {
                            style: "--pmthumb-ar: " + e.B + ";"
                        });
                    o ? this.ce(d, n, e, r, s) : this.ue(d, n, e, r, t.length), this.i.i_ui_odb && (d = this.i.i_ui_odb(d, e, r, this)), n.appendChild(d), this.me.appendChild(n), this.Rs.push(d)
                }), this.me
            }
            ue(t, i, s, r, o) {
                this.se ? this.ot(t, s, r) : this.Zs ? t.innerText = r + 1 : this.Gs && (t.innerText = r + 1 + "/" + o), e(i, "click", i => {
                    this.i.i_ui_dc ? this.i.i_ui_dc(t, r, this) : this.lt.Xi(r)
                }), this.vi && e(i, "mousemove", t => {
                    this.lt.Xi(r)
                })
            }
            ce(t, i, s, o, d) {
                this.ot(t, s, o);
                let n = h.u("vd-slider-dots_dot--view-more-overlay", [h.u("", "+ " + d), h.u("", "More")]);
                t.classList.add("vd-slider-dots_dot--view-more"), t.appendChild(n), e(i, "click", t => {
                    this.lt.q.Y(this.lt.q.xi[o]), r(() => {
                        this.lt.Xi(o)
                    }, 500)
                })
            }
            we() {
                this.te.Li(this._e, t => {
                    if (this.Ss()) {
                        var i = this._e.clientHeight / 2;
                        this.me.scrollTop += t ? -i : i
                    } else {
                        i = this._e.clientWidth / 2;
                        this.me.scrollLeft += t ? -i : i
                    }
                }), e(this.me, "scroll", t => {
                    this.te.zs(this.me, this._e)
                }), this.te.zs(this.me, this._e)
            }
            fe(t) {
                var i = ["vd-slider-dots vd-slider-dots--flex", "vd-slider-dots--mode-" + this.Ns, "vd-slider-dots--type-" + this.bs];
                return this.re && i.push("vd-slider-dots--" + this.re), h.u(i.join(" "), this.he(t))
            }
            Qs() {
                return !!this.i.i_ui_fvdom || window.innerWidth > this.i.i_mb
            }
            de(t) {
                this._e = this.fe(t), this.lt.ai.be.appendChild(this._e), this.rs(), r(() => {
                    this.rs()
                }, 100), r(() => {
                    this.rs()
                }, 500), this.ee && this.we()
            }
            rs() {
                "v" == this.Ks && this._e && (this._e.style.height = this.lt.ai.li.clientHeight + "px")
            }
            ot(t, i, s) {
                var e = 180;
                i.B > 1 && (e = Math.floor(e * i.B));
                var o = new l(i.V, this.i),
                    d = document.createElement("img");
                return d.className = "vd-slider-dots_thumb", d.setAttribute("sizes", e + "px"), i.T && "" != i.T && d.setAttribute("alt", i.T), d.C = i.C, d.j = i.j, r(() => {
                    h.I(d, o.o(e), o.l())
                }, this.i.i_ui_ndd ? 0 : 100 + 20 * s), t.appendChild(d), "video" != i.pt && "external" != i.pt || t.appendChild(h._.k()), "model" == i.pt && t.appendChild(h._.g(null, this.i)), t
            }
            ks(t) {
                switch (this.fs) {
                    case "arp":
                    case "aro":
                        return t ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/></svg>' : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>';
                    default:
                        return t ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M328 112L184 256l144 144"/></svg>' : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M184 112l144 144-144 144"/></svg>'
                }
            }
            ne() {
                this.te.Li(this.lt.ai.li, t => {
                    this.lt.cs(t ? -1 : 1)
                })
            }
            Fi(t, i) {
                this.ge(t, !0, i)
            }
            le() {
                this.ge(this.lt.ai.ve, !1, t => this.lt.Xi(t))
            }
            ge(t, i, s) {
                if (!this.ie) return;
                let e = this.Ds.Ms(i, s);
                e.length > 0 && t.appendChild(h.u("vd-slider--gallery-action-bar", e))
            }
        }
        history.pushState = (A = history.pushState, function() {
            var t = A.apply(this, arguments);
            return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("locationchange")), t
        }), history.replaceState = (t => function() {
            var i = t.apply(this, arguments);
            return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("locationchange")), i
        })(history.replaceState), window.addEventListener("popstate", () => {
            window.dispatchEvent(new Event("locationchange"))
        }), "undefined" != typeof window && window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(t, i) {
            i = i || window;
            for (var s = 0; s < this.length; s++) t.call(i, this[s], s, this)
        });
        let X = eval;
        class F {
            constructor(t, i, s, e, r) {
                this.ye = t, this.ai = i, this.i = e, this.xe = r, this.ke = (new Date).getTime(), this.ze = new D(this.ai, this), this.nt = new E(this), this.q = new H(this.ai, this), this.Zi = e.i_sf_frtl || "rtl" === getComputedStyle(this.ai.Ii.parentNode).direction, this.nt.Gs && (this.Zi = !1), this.Li(s)
            }
            Vi() {
                this.Hi() && (this.Se = this.ki, this.q = null, this.nt = null, this.ze.Vi(), this.ze = null, this.ai.Vi(), window.removeEventListener("resize", this.resizeEventListener))
            }
            Li(t) {
                this.Me = t, this.ws = this.Me.Ie, this.ki = this.Me.ki, this.ki > this.ws.length - 1 && (this.ki = 0), this.Se = this.ki, this.q.Li(this.ws, this.Se), this.nt.Li(this.ws, this.Se, this.xe), this.ws.length > 1 && this.es(), this.Ce(this.Se, this.Se), this.q.Bi(this.Se), this.je(this.Se), this.Ae(), this.i.i_sf_om && ("string" == typeof this.i.i_sf_om ? X(this.i.i_sf_om) : this.i.i_sf_om(this)), document.body.setAttribute("data-vd-slider-mounted", !0), this.Zi && this.ai.Ii.classList.add("vd-slider-root--rtl")
            }
            rs() {
                this.q && this.q.Hi() && (this.q.Bi(this.ki), this.q.Oi(this.ki), this.q.Bi(this.Se)), this.nt && this.nt.rs()
            }
            Hi() {
                return !!this.q
            }
            es() {
                this.Xi(this.ki)
            }
            os(t) {}
            cs(t, i) {
                this.Xi(function(t, i, s) {
                    return (i += s) >= t.length && (i = 0), i < 0 && (i = t.length - 1), i
                }(this.ws, this.Se, t), i, t)
            }
            Xi(t, i, s) {
                i = i || {}, this.os(i), t = Math.max(Math.min(t, this.ws.length - 1), 0);
                var e = this.Se;
                this.je(t), e != t && (this.Ce(t, e), this.Se = t, this.q.Oi(e), this.q.Bi(this.Se, {
                    hidden: i.hidden
                }), this.nt.Oi(e), this.nt.Bi(this.Se, {
                    variantChanged: i.variantChanged
                }), this.Ae(), this.Le(), this.i.i_sf_esl && this.i.i_sf_esl(this, e))
            }
            Ce(t, i) {
                var s = Math.abs(t - i),
                    e = 0 == s || this.ws.length > 2 && s == this.ws.length - 1;
                this.i.i_sf_dnsa && (e = !1), this.ai.fi.setAttribute("skip-transition", e)
            }
            Ae() {
                "1" == this.i.haob && (this.ai.Ii.setAttribute("can-slide-left", this.He(-1)), this.ai.Ii.setAttribute("can-slide-right", this.He(1)))
            }
            Le() {
                this.ai.Ii.setAttribute("slide-changed", !0), r(() => {
                    this.ai.Ii.removeAttribute("slide-changed")
                }, 500)
            }
            He(t) {
                return !(t < 0 && 0 == this.Se) && !(t > 0 && this.Se == this.ws.length - 1)
            }
            Ve() {
                return this.q.xi[this.Se]
            }
            Bs() {
                let t = this.Ve();
                t && t.kt && t.kt()
            }
            je(t) {
                let i = this.ws[t];
                this.ai.Be.textContent = i.T || ""
            }
            St(t) {
                this.Ve().St && this.Ve().St(t)
            }
        }
        class Z {
            constructor(t) {
                this.fi = h.u("vd-slider-own--slides-track"), this.li = h.u("vd-slider-own--slides", this.fi), this.Re = h.u("vd-slider-own--overlay"), this.ve = h.u("vd-slider-own--actions"), this.Be = h.u("vd-slider-own--alt-text"), this.be = h.u("vd-slider-dots-wrapper"), this.zi = h.u("vd-slider-own--slides-wrapper", [this.li, this.Re, this.Be, this.ve]), this.Ii = h.u("vd-slider-root vd-slider-own", [this.zi, this.be], {
                    tabindex: "0",
                    "aria-label": "Gallery"
                })
            }
            Vi() {
                this.Ii.parentNode.removeChild(this.Ii)
            }
        }

        function G(t) {
            var s, o, d, n, l, a = t.i_m_ivonpl && !t.eov;

            function p(i, e, n) {
                if (s) {
                    var a = i.De(e);
                    if (l && l.Te(a)) return !1;
                    if (0 === a.Ie.length) return !1;
                    l = a, o && (t.i_ui_ndd = !0, d = o, r(() => {
                        d && d.Vi()
                    }, 200));
                    var p = new Z(t);
                    return s.appendChild(p.Ii), t.i_m_cwi && s.parentElement.querySelectorAll("img:not([pmimg-loaded])").forEach((function(t) {
                        let i = "data:image/gif;base64,R0l";
                        t.setAttribute("src", i), t.setAttribute("srcset", i)
                    })), t.i_m_dncb || function(i, s) {
                        var e = [".htusb-ui-coll-boost", "._lably_item__main"];
                        t.i_m_ebs && (e = e.concat(t.i_m_ebs));

                        function o(t) {
                            const e = i.querySelector(t),
                                r = s.Re.querySelector(t);
                            if (e && !r) {
                                const t = e.cloneNode(!0);
                                s.Re.appendChild(t)
                            }
                        } [1e3, 5e3, 1e4, 15e3, 2e4].forEach(t => {
                            r(() => {
                                e.forEach(o)
                            }, t)
                        })
                    }(s.parentElement, p), W(i, n, p, !0), o = new F(i, p, a, t, n), !0
                }
            }

            function m(t) {
                var i = t.i_mo_rs,
                    e = document.querySelector(i);
                e && (s = h.u("vd-slider-mount"), t.i_mo_rs_r ? (e.innerHTML = "", e.appendChild(s)) : t.i_mo_rs_a ? e.appendChild(s) : e.parentNode.replaceChild(s, e))
            }

            function c(e, r) {
                ! function(t, s, e) {
                    if (t() || 0 == s) return;
                    var r = 0;
                    window.vdSliderIterator && clearInterval(window.vdSliderIterator);
                    window.vdSliderIterator = ((t, s, ...e) => window.setInterval(i(t), s, ...e))((function() {
                        ((r += e) > s || t()) && clearInterval(window.vdSliderIterator)
                    }), e)
                }((function() {
                    return !!s || (t.i_mo_fwn ? s = t.i_mo_fwn(e) : (m({
                        i_mo_rs: ".vd-slider-manual-install",
                        i_mo_rs_r: !0
                    }), s || m({
                        i_mo_rs: ".rio-media-gallery"
                    }), s || m(t), !s && t.tc && m(t.tc)), s ? (r(), !0) : void 0)
                }), 5e3, 100)
            }

            function u(i) {
                if (o) {
                    if (document.querySelector(".vd-slider-root")) return;
                    try {
                        o.Vi()
                    } catch (t) {}
                    o = null, s = null, l = null, n = null
                }
                c(i, (function() {
                    let s = i.Ne();
                    n = s || i.Oe;
                    var r = i.Pe(n) || i.Ee();
                    a && (s || (r = i.ws[0])), t.i_mo_fbmi && (r = t.i_mo_fbmi(i, n, r)), p(i, r, n), e(window, "vd-slider:show_variant", (function(t) {
                        f(i, t.detail.id)
                    })), t.i_m_svcba || (e(document, "vsk:product:variant:changed", (function(t) {
                        w(i, t.detail.variantId, "vsk:product:variant:changed")
                    })), e(window, "globoSwatchClickedVariantSwatch", (function(t) {
                        w(i, t.detail.id, "globoSwatchClickedVariantSwatch")
                    })))
                }))
            }

            function w(t, i, s) {
                let e = Date.now();
                r(() => {
                    f(t, parseInt(i), e)
                }, 300)
            }
            let _ = 0;

            function f(i, s, e) {
                o && (e && _ && _ > e || (t.i_mo_hvc ? t.i_mo_hvc(o, i, s, b) : b(i, s), _ = Date.now()))
            }

            function b(i, s) {
                if (s && s != n) {
                    if (o.Me.Xe) {
                        var e = i.Pe(s);
                        if (e) {
                            var d = p(i, e, s);
                            n = s
                        }
                    } else {
                        var l = o.Me.Fe(s);
                        if (null != l) {
                            var a = o.Me.Fe(n);
                            if (o.Se != l && l != a) {
                                o.Xi(l, {
                                    variantChanged: !0
                                });
                                d = !0
                            }
                            n = s, W(i, s, o.ai, !1)
                        }
                    }
                    t.i_mo_sovc && window.innerWidth < t.i_mb && d && r((function() {
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                    }), 100)
                }
            }
            return {
                Li: u,
                Ze: function(t) {
                    f(t, t.Ne()), r(() => {
                        u(t)
                    }, 100)
                }
            }
        }

        function W(t, i, s, e = !1) {
            let r = new CustomEvent("vd-slider:gallery_mounted", {
                detail: {
                    product: t.Ge,
                    variantId: i,
                    rootNode: s.Ii,
                    isRemounted: e
                }
            });
            setTimeout(() => {
                document.dispatchEvent(r)
            }, 10)
        }

        function q(t, i, s) {
            return {
                Ie: t,
                ki: i,
                Xe: s,
                Fe: function(i) {
                    for (let s = 0; s < t.length; s++) {
                        const e = t[s];
                        if (e.We && -1 != e.We.indexOf(i)) return s
                    }
                },
                Te: function(t) {
                    return this.Ie.map(t => t.H).join(",") == t.Ie.map(t => t.H).join(",")
                }
            }
        }
        class J {
            constructor(t, i, s) {
                this.Ge = t, this.qe = i, this.i = s, this.ws = [], this.Je = {}, this.Ye = {}, this.Oe, this.$e = {}
            }
            Ke() {
                var t = ["0"],
                    i = new Y(this, this.Ye);
                this.ws.forEach((s, e) => {
                    s.We && s.We.length > 0 && (t = s.We, i.Ue(s.We)), i.Qe(s, e), t.forEach(t => {
                        this.Je[t] = this.Je[t] || [], this.Je[t].push(s), this.Je[t].length <= 2 && "image" == s.pt && this.tr(s)
                    })
                }), i.ir()
            }
            sr() {
                var t = 0,
                    i = !1;
                this.ws.forEach((s, e) => {
                    var r = s.er && s.er.position;
                    r && (s.We && s.We.length > 0 ? i = !1 : r > t + 1 && (i = !0), t = r, i && (s.rr = !0))
                })
            }
            tr(t) {
                let i = this.i.i_p_pmiw || 360;
                i < 0 || t.H && !t.C && (t.j = i, t.C = new l(t.H, this.i).o(t.j), r(() => {
                    document.createElement("img").src = t.C
                }, 3e3))
            }
            or() {
                this.ws.forEach((t, i) => {
                    if (t.We && t.We.length > 0) {
                        t.We.forEach(i => {
                            this.Je[i] = [t], this.tr(t)
                        })
                    } else this.Je[0] = this.Je[0] || [], this.Je[0].push(t)
                })
            }
            dr() {
                var t = null;
                this.Ge.variants.forEach(i => {
                    if (i.featured_image && i.featured_media) {
                        var s = i.featured_image.variant_ids;
                        if (s && s.length > 0) {
                            var e = this.$e[i.featured_media.position];
                            null == e && (e = i.featured_media.position), this.ws[e].We = s, t = this.ws[e]
                        }
                    } else this.i.i_p_pvfp && t && t.We.push(i.id);
                    !this.Oe && i.available && (this.Oe = i.id), this.Ye[i.id] = i
                }), !this.Oe && this.Ge.variants[0] && (this.Oe = this.Ge.variants[0].id), this.Je = {}, this.i.i_p_savi && this.sr(), this.i.i_p_bmibvi ? this.i.i_p_bmibvi(this) : 1 == this.i.vis ? this.or() : this.Ke()
            }
            nr() {
                this.ws = [];
                let t = this.Ge.media;
                this.i.i_p_pmitp && (t = this.i.i_p_pmitp(t, this));
                for (var i = 0; i < t.length; i++) {
                    var s = t[i],
                        e = {
                            er: s,
                            lr: i,
                            We: s.variant_ids,
                            T: s.alt || this.Ge.title
                        };
                    if (this.$e[s.position] = i, this.i.i_p_pmi) {
                        var r = this.i.i_p_pmi(s, e, this);
                        if (r) {
                            this.ws.push(r);
                            continue
                        }
                    }
                    switch (s.media_type) {
                        case "image":
                            $(s, e), this.ws.push(Object.assign({
                                pt: "image",
                                H: s.src,
                                V: s.src,
                                B: s.aspect_ratio,
                                et: s.width,
                                rt: s.height
                            }, e));
                            break;
                        case "video":
                            this.ws.push(Object.assign({
                                pt: "video",
                                bt: s.sources,
                                V: s.preview_image.src,
                                B: s.aspect_ratio
                            }, e));
                            break;
                        case "external_video":
                            "youtube" == s.host ? this.ws.push(Object.assign({
                                pt: "external",
                                H: "https://www.youtube.com/embed/" + s.external_id,
                                V: s.preview_image.src,
                                B: s.preview_image.aspect_ratio
                            }, e)) : "vimeo" == s.host && this.ws.push(Object.assign({
                                pt: "external",
                                H: "https://player.vimeo.com/video/" + s.external_id + "?byline=0&controls=1&playsinline=1&title=0",
                                V: s.preview_image.src,
                                B: s.preview_image.aspect_ratio
                            }, e));
                            break;
                        case "model":
                            this.ws.push(Object.assign({
                                pt: "model",
                                bt: s.sources,
                                V: s.preview_image.src,
                                B: s.preview_image.aspect_ratio
                            }, e))
                    }
                }
                this.dr(), this.i.i_pf_apmi && (this.ws = this.i.i_pf_apmi(this.ws))
            }
            pr() {
                this.ws = [];
                for (var t = 0; t < this.Ge.images.length; t++) {
                    var i = this.Ge.images[t];
                    this.ws.push({
                        pt: "image",
                        H: i.src,
                        V: i.src,
                        B: i.width / i.height,
                        et: i.width,
                        rt: i.height,
                        er: null,
                        lr: t,
                        We: this.Ge.images[t].variant_ids,
                        T: i.alt || this.Ge.title
                    })
                }
                this.dr()
            }
            hr(t) {
                let i = ["image"];
                this.i.ev && (i.push("video"), i.push("external")), this.i.em && i.push("model");
                var s = [];
                for (let e = 0; e < t.length; e++) {
                    const r = t[e];
                    let o = -1 != i.indexOf(r.pt),
                        d = this.i.i_pf_rmi && this.i.i_pf_rmi(r, e);
                    !o || d || r.rr || s.push(r)
                }
                return s
            }
            mr(t) {
                if (window.vdSliderIsProductPreview) {
                    this.qe = this.Ge.handle, this.Ge = null;
                    var i = window.location.href.split("?").join(".json?")
                } else i = location.origin + "/products/" + this.qe + ".json";
                this.Ge ? t() : fetch(i).then(i => {
                    i.text().then(i => {
                        try {
                            this.Ge = JSON.parse(i).product
                        } catch (t) {
                            console.warn("[vd-slider] product JSON fetch (" + location.origin + "/products/" + this.qe + ".json) returned non-JSON, gallery will not mount:", i);
                            return
                        }
                        t()
                    }).catch(s)
                }).catch(s)
            }
            cr(t) {
                this.mr(() => (this.Ge.media ? this.nr() : (console.warn("[vd-slider] product.json has no 'media' array, falling back to images-only gallery (video/model slides will be dropped). Product:", this.Ge.handle || this.qe), this.pr()), t()))
            }
            De(t) {
                var i = t.We && t.We[0];
                if (i && 1 == this.i.eov) {
                    var s = this.Je[0] || [],
                        e = this.Je[i] || [],
                        r = this.hr(e.concat(s));
                    if (this.i.i_pf_gmis)
                        if (d = this.i.i_pf_gmis(this, e, s, r)) return d;
                    if (e.length > 0) return q(r, 0, !0)
                }
                let o = this.hr(this.ws);
                var d;
                if (this.i.i_pf_gmis_nv && (d = this.i.i_pf_gmis_nv(this, o, t.lr))) return d;
                return q(o, t.lr, !1)
            }
            Ee() {
                return this.Pe(this.Oe) || this.ws[0]
            }
            Ne() {
                var t = document.location.href.split("variant=");
                if (t.length > 1) return parseInt(t[1].split("&")[0])
            }
            Pe(t) {
                return this.Je[t] && this.Je[t][0]
            }
            ur(t) {
                if (this.Ge) {
                    var i = this.Ge.tags;
                    if ("string" == typeof i && (i = i.split(", ")), -1 != i.indexOf(t)) return !0
                }
            }
        }
        class Y {
            constructor(t, i) {
                this.ye = t, this.Ye = i, this.wr = [], this._r()
            }
            _r() {
                this.br = "0", this.gr = [], this.vr = []
            }
            Ue(t) {
                this.yr(), this.br = t, this.gr = [], this.vr = []
            }
            Qe(t, i) {
                this.gr.push(i + 1), t.rr && this.vr.push(i + 1)
            }
            yr() {
                this.wr.push([this.br, this.gr, this.vr])
            }
            ir() {
                this.yr()
            }
        }

        function $(t, i) {
            let s = window.vdSliderFeaturedImage;
            var e, r;
            s && s.src == t.src && (e = s.preloadedSrc, r = s.forWidth, e && -1 != e.indexOf(r + "x") && (i.C = s.preloadedSrc, i.j = s.forWidth))
        }

        function K(t) {
            var i, s = t.match(/.{2}/g),
                e = function(t) {
                    return parseInt(t, 16)
                };
            return "rgba(" + [e(s[0]), e(s[1]), e(s[2]), (i = s[3], i ? parseFloat(parseInt(parseInt(i, 16) / 255 * 1e3) / 1e3) : 100)].join(",") + ")"
        }

        function U(t, i) {
            return t.i_si_rules && (i = i.concat(t.i_si_rules)), t.i_si_rules_e && (i = i.concat(t.i_si_rules_e)), t.i_mo_rs && (t.i_mo_rs_r ? t.i_mo_rs.split(",").forEach(t => {
                i.push(t + " > :not(.vd-slider-mount):not(.vd-slider-manual-install) { opacity: 0 !important; }")
            }) : t.i_mo_rs_a ? t.i_mo_rs.split(",").forEach(t => {
                i.push(t + " > :not(.vd-slider-mount):not(.vd-slider-manual-install) { display: none !important; }"), window.vdSliderFeaturedImage && window.vdSliderFeaturedImage.aspect_ratio && i.push("body:not([data-vd-slider-mounted]) " + t + " { aspect-ratio: " + window.vdSliderFeaturedImage.aspect_ratio + "; }")
            }) : i.push(t.i_mo_rs + " { opacity: 0 !important; }")), i
        }

        function Q(t, i, s) {
            i in t || (t[i] = s)
        }

        function tt(t) {
            var i = window.Shopify && window.Shopify.theme;
            i && (! function(t, i) {
                switch (t.theme_store_id) {
                    case 857:
                        Q(i, "i_mo_rs", ".page-content--product [data-product-images]");
                        break;
                    case 855:
                        Q(i, "i_mo_rs", ".Product__Wrapper .Product__Gallery"), Q(i, "i_si_rules", [".vd-slider-root { margin-bottom: 28px; }"]);
                        break;
                    case 798:
                        Q(i, "i_mo_rs", ".product .product__media-container .product__media"), Q(i, "i_mo_rs_r", !0), Q(i, "i_si_rules", [".product__media-container .product-thumbnails, .product__media-action { display: none; }"]);
                        break;
                    case 902:
                        Q(i, "i_mo_rs", ".page-content--product [data-product-images]");
                        break;
                    case 871:
                        Q(i, "i_mo_rs", ".product-block-list .product-gallery"), Q(i, "i_si_rules", [".vd-slider-root { z-index: 1; }"]);
                        break;
                    case 847:
                    case 872:
                        Q(i, "i_mo_rs", ".product-section [data-product-images]");
                        break;
                    case 868:
                        Q(i, "i_mo_rs", ".product__page .product__slides"), Q(i, "i_si_rules", [".product__page [data-product-thumbs] { display: none; }", ".vd-slider-root { width: 100% }"]);
                        break;
                    case 838:
                        Q(i, "i_mo_rs", ".product--container .product-gallery, .product__container .product-gallery"), Q(i, "i_mo_rs_a", !0), Q(i, "i_si_rules", [".product--container .product-gallery--viewer, .product-gallery .product-gallery--navigation { display: none; }", ".vd-slider-root { width: 100% }"]);
                        break;
                    case 739:
                        Q(i, "i_mo_rs", ".product-single .product__media__wrapper"), Q(i, "i_mo_rs_r", !0);
                        break;
                    case 606:
                        Q(i, "i_mo_rs", ".product-page--media .product-media--wrapper, .product-media--wrapper"), Q(i, "i_si_rules", [".product-page--thumbs { display: none; }", ".vd-slider-root { width: 100% }"]);
                        break;
                    case 801:
                        Q(i, "i_mo_rs", ".product-images-container .product-medias");
                        break;
                    case 836:
                        Q(i, "i_mo_rs", ".product-single .product-single__photos");
                        break;
                    case 411:
                        Q(i, "i_mo_rs", ".product-medias"), Q(i, "i_mo_rs_a", !0), Q(i, "i_si_rules", [".product-single__thumbnails { height: 0; padding: 0 !important; overflow: hidden; }", ".product-single__medias { display: none; }"]);
                        break;
                    case 849:
                        Q(i, "i_mo_rs", ".product .productImgSlider, .product .productImgScroller"), Q(i, "i_si_rules", [".productImgSlider-nav, .productImgScroller-nav { display: none; }"]);
                        break;
                    case 765:
                        Q(i, "i_mo_rs", ".product-page--top-panel .product-media--root"), Q(i, "i_si_rules", [".product-page--content .product-page--media-variant { display: none; }"]);
                        break;
                    case 677:
                        Q(i, "i_mo_rs", ".theme-gallery.product-slider"), Q(i, "i_si_rules", [".product-area__details__thumbs { display: none !important; }"])
                }
            }(i, t), function(t, i) {
                switch (t.theme_store_id) {
                    case 829:
                        Q(i, "i_mo_rs", ".product-template .product-template__media, .product-template .product__image-container, .product-template .product__media-container"), Q(i, "i_si_rules", [".product__submedia-list, .product__subimage-list { display: none !important; }"]);
                        break;
                    case 796:
                        Q(i, "i_mo_rs", ".product-single .product-single__photos, .product-single .product-single__media-group"), Q(i, "i_mo_rs_r", !0);
                        break;
                    case 775:
                        Q(i, "i_mo_rs", ".product-single .photos");
                        break;
                    case 766:
                        Q(i, "i_mo_rs", ".product__photo:first-of-type"), Q(i, "i_mo_rs_r", !0), Q(i, "i_si_rules", [".product__photo:not(:first-of-type) { display: none }", "@media only screen and (min-width: 750px) { .product__photo:first-of-type { margin: auto; float: initial; padding: 0; } }"]);
                        break;
                    case 578:
                        Q(i, "i_mo_rs", ".product-single > .grid__item:first-child"), Q(i, "i_mo_rs_r", !0);
                        break;
                    case 730:
                        Q(i, "i_mo_rs", ".product-single > .grid__item:first-child"), Q(i, "i_mo_rs_a", !0);
                        break;
                    case 679:
                        Q(i, "i_mo_rs", ".grid-item .product-photo-container"), Q(i, "i_si_rules", [".grid-item .product-photo-thumbs { display: none }", ".vd-slider-root { margin-bottom: 30px; }"]);
                        break;
                    case 380:
                        Q(i, "i_mo_rs", ".product-single .product-single__photos"), Q(i, "i_si_rules", [".product-single #ProductThumbs { display: none !important; }"]);
                        break;
                    case 885:
                        Q(i, "i_mo_rs", ".product-content-wrapper .product__gallery"), Q(i, "i_si_rules", [".product-content-wrapper .gallery-indicator { display: none !important; }"]);
                        break;
                    case 887:
                        Q(i, "i_mo_rs", ".product slider-component"), Q(i, "i_si_rules", ["[data-vd-slider-custom] .vd-slider-dots, [data-vd-slider-custom] .vd-slider-arrows { z-index: 2 }"]);
                    case 1356:
                    case 1431:
                    case 1363:
                    case 1368:
                    case 1434:
                    case 1567:
                    case 1500:
                    case 1499:
                        Q(i, "i_mo_rs", ".product .product__media-wrapper"), Q(i, "i_mo_rs_a", !0)
                }
            }(i, t), function(t) {
                return !!t.i_mo_rs || !!t.tc
            }(t) || (t.i_e_sp = function() {
                return !0
            }, window.vdSlider_i_e_tl_tns && window.vdSlider_i_e_tl_tns()))
        }

        function it() {
            var t = function() {
                for (const t in document.scripts) {
                    let i = document.scripts[t];
                    if (i.src && -1 != i.src.indexOf("pmslider.netlify.app/s")) return i.src
                }
            }();
            if (!t) return {};
            var i = {};
            return t.replace(/[?&]+([^=&]+)=([^&]*)/gi, (function(t, s, e) {
                i[s] = unescape(e)
            })), i
        }

        function st() {
            var t = Object.assign({
                i_mb: 800,
                v: 4
            }, it(), window.vdSliderInstallConfig || {}, window.vdSliderConfig || {});
            return t.tc = t.tc || window.vdSliderInstallConfig && window.vdSliderInstallConfig.tc, (t = rt(t = function(t) {
                t.m && window.innerWidth < t.i_mb && (t = Object.assign(t, t.m));
                return t
            }(t))).tc && (t.tc = rt(t.tc)), t.get = function(i) {
                return t.tc && t.tc[i] || t[i]
            }, t.exec = function(i, ...s) {
                let e = t.get(i);
                if (e) return function(t, ...i) {
                    "string" == typeof t && (t = new Function("return " + t)());
                    if (t) return t(...i)
                }(e, ...s)
            }, t
        }
        let et = eval;

        function rt(t) {
            return t.i_cm ? (t.i_cm.forEach((function({
                c: i,
                m: s
            }) {
                et(i) && (t = Object.assign(t, s))
            })), t) : t
        }

        function ot() {
            r((function() {
                try {
                    document.body && document.body.setAttribute("data-vd-slider-custom", !0)
                } catch (t) {}
            }), 100)
        }

        function dt(t, i, s) {
            if (function(t) {
                    var i = 1 == t.ds || "true" == t.ds,
                        s = K(t.dc1 || t.i_ddc1 || "000000"),
                        e = K(t.dc2 || t.i_ddc2 || "D9D8D8"),
                        r = K(t.ac1 || t.i_dac1 || "000000"),
                        o = K(t.abg || "ffffff");

                    function d(i) {
                        return "@media (min-width: " + t.i_mb + "px) { " + i + " }"
                    }

                    function n(i) {
                        return "@media (max-width: " + t.i_mb + "px) { " + i + " }"
                    }
                    let l = [];
                    var a = [];
                    t.asc && a.push("--vd-slider-asc: " + t.asc), t.dsc && a.push("--vd-slider-dsc: " + t.dsc);
                    var p = a.length ? " " + a.join("; ") + ";" : "";
                    l.push(".vd-slider-root { overflow: hidden; position: relative; display: flex; flex-direction: column; justify-content: center; z-index: 1; width: 100%; margin: auto; margin-bottom: 1rem;" + p + " }"), t.i_si_shl || (l.push(d(".vd-slider-root:not(.vd-slider-root--ar-fw):not(.vd-slider-root--dl-v) { max-width: calc(var(--vd-slider-ar) * 100vh); margin: auto; }")), l.push(d(".vd-slider-root.vd-slider-root--dl-v { max-width: calc(var(--vd-slider-ar) * 120vh); margin: auto; }"))), l.push(".vd-slider-root.vd-slider-root--ar-fw .vd-slider-own--slides-wrapper { height: 70vh; min-height: 350px; }"), l.push(".vd-slider-root .vd-slider-own--overlay { position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; pointer-events: none; }"), l.push(".vd-slider-root, .vd-slider-root * { -webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none; -webkit-tap-highlight-color: rgba(0,0,0,0); direction: ltr; }"), l.push(".vd-slider-root.vd-slider-root--ar-fw .vd-slider-own--slides { height: 100%; padding: 0 !important; }"), l.push(".vd-slider-root.vd-slider-root--fits .vd-slider-dots, .vd-slider-root.vd-slider-root--fits .vd-slider-arrows { display: none !important; }"), l.push(".vd-slider-root.vd-slider-root--fits .vd-slider-own--slides-track { transform: none !important; justify-content: center; }"), l.push(".vd-slider-slide video, .vd-slider-slide iframe, .vd-slider-slide .plyr__video-wrapper { background-color: transparent; }"), l.push(".vd-slider-slide--inner .plyr { --plyr-color-main: #000000a1; width: 100%; height: 100%; pointer-events: all; background-color: transparent; }"), l.push(".vd-slider-slide--inner .plyr--youtube, .vd-slider-slide--inner .plyr--vimeo { margin: 0; position: absolute; top: 50%; transform: translateY(-50%); }"), l.push(".vd-slider-slide--inner .plyr__video-wrapper { height: unset; }"), l.push(".vd-slider-slide--inner .plyr__control svg { height: 22px; width: 22px; }"), l.push(".vd-slider-slide--inner .plyr__control--overlaid { padding: 26px; }"), l.push(".vd-slider-slide--inner .plyr__video-embed__container { margin-left: -1px; margin-right: -1px; }"), l.push(".vd-slider-slide--inner[data-portrait='false'] .plyr--vimeo .plyr__video-wrapper { width: unset; height: 100%; }"), l.push(".vd-slider-slide--inner[data-portrait='true'] .plyr--vimeo .plyr__video-wrapper { width: 100%; max-height: 100%; }"), l.push(".vd-slider-slide--inner .plyr iframe { pointer-events: none !important; }"), l.push(".vd-slider-slide--inner .plyr * { pointer-events: all; }"), l.push(".vd-slider-slide--inner .plyr__control { min-width: 0 !important; min-height: 0 !important; -webkit-appearance: none !important; appearance: none !important; color: var(--plyr-video-control-color, #fff) !important; }"), l.push(".vd-slider-slide--inner .plyr video { display: block !important; }"), l.push(".vd-slider-slide--inner .plyr__control::before, .vd-slider-slide--inner .plyr__control::after { content: none !important; }"), l.push(".vd-slider-slide--inner .plyr__control:not(.plyr__control--overlaid), .vd-slider-slide--inner .plyr__control:not(.plyr__control--overlaid):hover { transform: none !important; }"), l.push(".vd-slider-slide--inner .plyr__control--overlaid, .vd-slider-slide--inner .plyr__control--overlaid:hover { transform: translate(-50%, -50%) !important; }"), l.push(".vd-slider-root.vd-slider-root--dl-v { flex-direction: row; direction: rtl; }"), l.push(".vd-slider-root.vd-slider-root--dl-v > * { direction: ltr; }"), l.push(".vd-slider-own--slides-wrapper { position: relative; width: 100%; height: 100%; }"), l.push(".vd-slider-own--slides { position: relative; overflow: hidden; }"), l.push(".vd-slider-own--alt-text { display: block; text-align: center; width: 100%; }"), t.i_si_satb || l.push(".vd-slider-own--alt-text { display: none; }"), l.push(".vd-slider-own--slides > * { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }"), l.push("@keyframes vd-slider-own-animation-fade-in { from { opacity: .3; } to { opacity: 1; } }"), l.push(".vd-slider-root { -webkit-animation: vd-slider-own-animation-fade-in .3s;-moz-animation: vd-slider-own-animation-fade-in .3s;-o-animation: vd-slider-own-animation-fade-in .3s;animation: vd-slider-own-animation-fade-in .3s; }"), l.push(".vd-slider-own--slides-track { display: flex; overflow: visible; transition: transform 0.35s ease; }"), l.push(".vd-slider-own--slides-track[skip-transition='true'] { transition-duration: 0.01s; }"), l.push(".vd-slider-own--slides-track .vd-slider-slide { height: 100%; max-width: 100%; width: unset; position: relative; transition: all 0.2s ease; }"), l.push(".vd-slider-own--slides-track .vd-slider-slide img { display: inline-block; height: 100%; width: 100%; pointer-events: none; object-fit: cover; background-size: cover; transition: all 0.2s ease; }"), l.push(".vd-slider-root.vd-slider-root--zoom-click .vd-slider-slide, .vd-slider-slide.vd-slider-slide--preview { cursor: pointer; }"), l.push(".vd-slider-own--slides-track .vd-slider-slide .vd-slider-slide--inner { height: 100%; width: 100%; max-width: 100%; }"), l.push(".vd-slider-slide img:not([pmimg-loaded]) { opacity: 0; }"), l.push(".vd-slider-slide img[pmimg-loaded] { opacity: .7; }"), l.push(".vd-slider-slide[data-vd-slider-slide-active='true'] img[pmimg-loaded], .vd-slider-root.vd-slider-root--fits .vd-slider-slide img[pmimg-loaded] { opacity: 1; }"), l.push(".vd-slider-slide:not([data-vd-slider-slide-active='true']) .plyr__controls, .vd-slider-slide:not([data-vd-slider-slide-active='true']) button, .vd-slider-slide:not([data-vd-slider-slide-active='true']) button { display: none !important; }"), l.push(".vd-slider-slide--inner video { height: 100%; width: 100%; pointer-events: none; object-fit: contain; }"), l.push(".vd-slider-slide--inner.vd-slider-preview-autoplay video { pointer-events: all; }"), l.push(".vd-slider-slide:not(.vd-slider-slide--loaded) { opacity: 0; }"), l.push(".vd-slider-slide.vd-slider-slide--loaded { opacity: 1; }"), l.push(".vd-slider-root--transition-fade .vd-slider-slide { position: absolute; }"), l.push(".vd-slider-root--transition-fade .vd-slider-slide .vd-slider-slide--inner { opacity: 0 !important; transition: opacity 0.5s ease; }"), l.push(".vd-slider-root--transition-fade .vd-slider-slide[data-vd-slider-slide-active='true'] .vd-slider-slide--inner { opacity: 1 !important; }"), l.push(".vd-slider-root--transition-fade .vd-slider-slide:not([data-vd-slider-slide-active='true']):not([data-vd-slider-slide-previous]) { opacity: 0 !important; }"), l.push(".vd-slider-root.vd-slider-root--ar-fit .vd-slider-slide img { object-fit: contain; width: 100%; background-size: contain; }"), l.push(".vd-slider-root.vd-slider-root--ar-fit.vd-slider-root--ar-fix .vd-slider-slide img { object-fit: contain; width: 100%; background-size: contain; }"), l.push(".vd-slider-root--animation-right .vd-slider-slide { -webkit-animation: vd-slider-animation-right 0.1s;-moz-animation: vd-slider-animation-right 0.1s;-o-animation: vd-slider-animation-right 0.1s;animation: vd-slider-animation-right 0.1s; }"), l.push(".vd-slider-root--animation-left .vd-slider-slide { -webkit-animation: vd-slider-animation-left 0.1s;-moz-animation: vd-slider-animation-left 0.1s;-o-animation: vd-slider-animation-left 0.1s;animation: vd-slider-animation-left 0.1s; }"), l.push(".vd-slider-root--animation-fadein .vd-slider-slide { -webkit-animation: vd-slider-animation-fade-in 0.8s;-moz-animation: vd-slider-animation-fade-in 0.8s;-o-animation: vd-slider-animation-fade-in 0.8s;animation: vd-slider-animation-fade-in 0.8s; }"), l.push("@keyframes vd-slider-animation-right { from { transform: translateX(-100px); opacity: 0.7; } to { transform: translateX(0); opacity: 1; } }"), l.push("@keyframes vd-slider-animation-left { from { transform: translateX(100px); opacity: 0.7; } to { transform: translateX(0); opacity: 1; } }"), l.push("@keyframes vd-slider-animation-fade-in { from { opacity: 0.7; } to { opacity: 1; } }"), l.push(".vd-slider-dots { display: block; position: absolute; margin: 0; padding: 0; line-height: 0; width: 100%; pointer-events: none; opacity: 0; }"), l.push(".vd-slider-root.vd-slider-root--loaded .vd-slider-dots { opacity: 1; }"), l.push(".vd-slider-dots.vd-slider-dots--center { left: 50%; text-align: center;  }"), l.push(".vd-slider-dots.vd-slider-dots--center .vd-slider-dots_container { left: -50%;  }"), l.push(".vd-slider-root .vd-slider-dots.vd-slider-dots--flex { display: flex; justify-content: center; }"), l.push(".vd-slider-dots.vd-slider-dots--flex .vd-slider-dots_container { display: flex; overflow: scroll !important; pointer-events: all; scroll-behavior: smooth; -ms-overflow-style: none; scrollbar-width: none; }"), l.push(".vd-slider-dots.vd-slider-dots--flex .vd-slider-dots_container::-webkit-scrollbar { opacity: 0; width: 0; height: 0; }"), l.push(".vd-slider-root.vd-slider-root--dl-v .vd-slider-dots.vd-slider-dots--type-thumbs { justify-content: flex-start; }"), l.push(".vd-slider-dots { bottom: unset; position: relative; }"), l.push(".vd-slider-dots.vd-slider-dots--type-stretch_full, .vd-slider-dots.vd-slider-dots--type-stretch_half { bottom: -4px; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots.vd-slider-dots--type-stretch_full, .vd-slider-root--dl-v .vd-slider-dots.vd-slider-dots--type-stretch_half { bottom: -1px; }"), l.push(".vd-slider-dots.vd-slider-dots--left { left: 5%; }"), l.push(".vd-slider-dots.vd-slider-dots--right { right: 5%; }"), l.push(".vd-slider-dots_container { position: relative; padding: 4px; display: inline-block; direction: ltr; }"), l.push(".vd-slider-root.vd-slider-root--dl-v .vd-slider-dots, .vd-slider-root.vd-slider-root--dl-v .vd-slider-dots_container { flex-direction: column; }"), l.push(".vd-slider-root.vd-slider-root--dl-v .vd-slider-dots--type-counter { width: auto; position: absolute; top: 5px; justify-content: flex-start; }"), l.push(".vd-slider-root:not(.vd-slider-root--dl-v) .vd-slider-dots.vd-slider-dots--type-thumbs .vd-slider-dots_container { padding: 4px 0; }"), l.push(".vd-slider-root.vd-slider-root--dl-v .vd-slider-dots.vd-slider-dots--type-thumbs .vd-slider-dots_container { padding: 0 4px; }"), l.push(".vd-slider-root:not(.vd-slider-root--dl-v) .vd-slider-dots.vd-slider-dots--type-thumbs .vd-slider-dots_dot-wrapper:first-of-type { padding-left: 2px; }"), l.push(".vd-slider-root.vd-slider-root--dl-v .vd-slider-dots.vd-slider-dots--type-thumbs .vd-slider-dots_dot-wrapper:first-of-type { padding-top: 2px; }"), l.push(".vd-slider-arrows-wrapper { pointer-events: none; z-index: 2; }"), l.push(".vd-slider-arrows { display: block; position: absolute; margin: 0; padding: 0; line-height: 0; width: 100%; opacity: 0; }"), l.push(".vd-slider-arrows * { box-sizing: border-box; }"), l.push(".vd-slider-root.vd-slider-root--loaded .vd-slider-arrows { opacity: 1; }"), l.push(".vd-slider-arrows--position-bs, .vd-slider-arrows--position-bl, .vd-slider-arrows--position-bs { bottom: 2px; }"), l.push(".vd-slider-arrows--position-ts, .vd-slider-arrows--position-tl { top: 2px; }"), l.push(".vd-slider-arrows--position-ms { top: 50%; }"), l.push(".vd-slider-arrows_container { position: relative; margin: 0; padding: 0; width: 100%; }"), l.push(".vd-slider-arrows_arrow { position: relative; padding: 0; height: 100%; }"), l.push(".vd-slider-arrows--aro .vd-slider-arrows_arrow, .vd-slider-arrows--cho .vd-slider-arrows_arrow { border-radius: 50%; -webkit-box-shadow: -3px 5px 10px -5px #000000; box-shadow: -3px 5px 10px -5px #000000; }"), l.push(".vd-slider-arrows_arrow svg { height: 100%; width: unset; padding: 8px; transition: transform 0.2s; }"), l.push(".vd-slider-arrows--chl .vd-slider-arrows_arrow svg { padding: 3px; }"), l.push(".vd-slider-arrows_area-left { left: 0; }"), l.push(".vd-slider-arrows_area-right { right: 0; }"), l.push(".vd-slider-root--rtl .vd-slider-own--slides, .vd-slider-root--rtl .vd-slider-own--slides-track > *, .vd-slider-root--rtl .vd-slider-dots-wrapper, .vd-slider-root--rtl .vd-slider-dots_container > *  { transform: scaleX(-1); transition: none; }"), l.push(".vd-slider-arrows--position-bl .vd-slider-arrows_area-right, .vd-slider-arrows--position-tl .vd-slider-arrows_area-right { left: 0; }"), l.push(".vd-slider-arrows--aro .vd-slider-arrows_area-right, .vd-slider-arrows--cho .vd-slider-arrows_area-right { margin-left: 4px; }"), l.push(".vd-slider-arrows_area { cursor: pointer !important; pointer-events: all; opacity: 0.85; display: inline-block; }"), l.push(".vd-slider-arrows--position-ms .vd-slider-arrows_area, .vd-slider-dots .vd-slider-arrows_area { transform: translateY(-50%); position: absolute; }"), l.push(".vd-slider-arrows--position-bs .vd-slider-arrows_area-right, .vd-slider-arrows--position-ts .vd-slider-arrows_area-right { position: absolute; }"), l.push(".vd-slider-arrows_area:hover { cursor: pointer !important; opacity: 1; }"), l.push(".vd-slider-arrows_area-left:hover svg { -webkit-transform: translateX(1px); -moz-transform: translateX(1px); transform: translateX(1px); }"), l.push(".vd-slider-arrows_area-right:hover svg { -webkit-transform: translateX(-1px); -moz-transform: translateX(-1px); transform: translateX(-1px); }"), l.push(".vd-slider-arrows_area { padding: 5px 6px; height: calc(56px * var(--vd-slider-asc, 1)); }"), l.push(".vd-slider-slide, .vd-slider-slide img { -webkit-backface-visibility: hidden; -webkit-perspective: 1000; -webkit-font-smoothing: antialiased; -webkit-transform-style: preserve-3d; -webkit-transform: translateZ(0);  }"), l.push(".vd-slider-arrows_arrow { stroke: " + r + "; color: " + r + "; }"), l.push(".vd-slider-arrows_arrow:hover, .vd-slider-arrows_arrow.vd-slider-arrows_arrow--hover { opacity: 1; }"), l.push(".vd-slider-root[can-slide-left='false'] .vd-slider-own--slides-wrapper .vd-slider-arrows_area-left { display: none; }"), l.push(".vd-slider-root[can-slide-right='false'] .vd-slider-own--slides-wrapper .vd-slider-arrows_area-right { display: none; }"), l.push("[can-scroll-left='false'] .vd-slider-arrows_area-left { display: none; }"), l.push("[can-scroll-right='false'] .vd-slider-arrows_area-right { display: none; }"), l.push(".vd-slider-root--show-arrows-on-hover .vd-slider-arrows_container { opacity: 0; transition: opacity .2s linear;}"), l.push(".vd-slider-root--show-arrows-on-hover:hover .vd-slider-arrows_container, .vd-slider-dots .vd-slider-arrows_container { opacity: 1; }"), l.push("[data-vd-slider-touch] .vd-slider-arrows_container { opacity: 1; }"), l.push(".vd-slider-dots .vd-slider-arrows { position: absolute; inset: 0; top: 50%; height: 100%; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots .vd-slider-arrows { position: absolute; inset: 0; top: 0; left: 50%; width: 100%; margin: 0; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots .vd-slider-arrows_area-left { top: 4px; transform: translateX(-50%) rotate(90deg); }"), l.push(".vd-slider-root--dl-v .vd-slider-dots .vd-slider-arrows_area-right { bottom: 4px; right: unset; transform: translateX(-50%) rotate(90deg); }"), l.push(".vd-slider-dots .vd-slider-arrows_container { height: 100%; }"), l.push(".vd-slider-dots .vd-slider-arrows_area { height: calc(45px * var(--vd-slider-asc, 1)); max-height: 70%; opacity: 0.95; margin: 0; }"), l.push(".vd-slider-dots_dot { display: inline-block; vertical-align: middle; padding: 0; background-color: " + e + "; transition: background-color 0.1s; }"), l.push(".vd-slider-dots_dot.vd-slider-dots_dot--current { background-color: " + s + "; }"), l.push(".vd-slider-dots, .vd-slider-dots *, .vd-slider-arrows, .vd-slider-arrows * { z-index: 2 }"), l.push(".vd-slider-dots_dot-wrapper { cursor: pointer !important; pointer-events: all; }"), l.push(".vd-slider-dots--type-zoomin .vd-slider-dots_dot-wrapper { padding: 3px; display: inline-block; vertical-align: middle; }"), l.push(".vd-slider-dots--type-zoomin .vd-slider-dots_dot { border-radius: 50%; width: calc(10px * var(--vd-slider-dsc, 1)); margin: 1px; height: calc(10px * var(--vd-slider-dsc, 1)); transition: 0.1s; }"), l.push(".vd-slider-dots--type-zoomin .vd-slider-dots_dot.vd-slider-dots_dot--current { width: calc(12px * var(--vd-slider-dsc, 1)); height: calc(12px * var(--vd-slider-dsc, 1)); margin: 0; }"), i ? l.push(".vd-slider-dots--type-zoomin .vd-slider-dots_dot { -webkit-box-shadow: 0 0 5px 1px #bbbbbb; -moz-box-shadow: 0 0 5px 1px #bbbbbb; box-shadow: 0 0 5px 1px #bbbbbb; }") : l.push(".vd-slider-dots--type-zoomin .vd-slider-dots_dot { -webkit-box-shadow: none; -moz-box-shadow: none; box-shadow: none; }"), l.push(".vd-slider-dots--type-outline .vd-slider-dots_dot-wrapper { padding: 2px; display: inline-block; vertical-align: middle; }"), l.push(".vd-slider-dots--type-outline .vd-slider-dots_dot { border-radius: 50%; width: calc(11px * var(--vd-slider-dsc, 1)); margin: 1px; height: calc(11px * var(--vd-slider-dsc, 1)); background-color: " + e + "; border: 0px solid " + e + "; transition: border-color 0.5s; }"), l.push(".vd-slider-dots--type-outline .vd-slider-dots_dot.vd-slider-dots_dot--current { border: 2px solid " + s + " }"), i ? l.push(".vd-slider-dots--type-outline .vd-slider-dots_dot { -webkit-box-shadow: 0 0 5px 1px #bbbbbb75; -moz-box-shadow: 0 0 5px 1px #bbbbbb75; box-shadow: 0 0 5px 1px #bbbbbb75; }") : l.push(".vd-slider-dots--type-outline .vd-slider-dots_dot { -webkit-box-shadow: none; -moz-box-shadow: none; box-shadow: none; }"), l.push(".vd-slider-dots--type-fillin .vd-slider-dots_dot-wrapper { padding: 3px; display: inline-block; vertical-align: middle; }"), l.push(".vd-slider-dots--type-fillin .vd-slider-dots_dot { border-radius: 50%; width: calc(11px * var(--vd-slider-dsc, 1)); margin: 1px; height: calc(11px * var(--vd-slider-dsc, 1)); background-color: transparent; border: 1px solid " + e + "; transition: background-color 0.3s; }"), l.push(".vd-slider-dots--type-fillin .vd-slider-dots_dot.vd-slider-dots_dot--current { background-color: " + s + "; border: 1px solid " + e + " }"), i ? l.push(".vd-slider-dots--type-fillin .vd-slider-dots_dot { -webkit-box-shadow: 0 0 5px 1px #bbbbbb75; -moz-box-shadow: 0 0 5px 1px #bbbbbb75; box-shadow: 0 0 5px 1px #bbbbbb75; }") : l.push(".vd-slider-dots--type-fillin .vd-slider-dots_dot { -webkit-box-shadow: none; -moz-box-shadow: none; box-shadow: none; }"), l.push(".vd-slider-dots--type-minimal .vd-slider-dots_dot-wrapper { padding: 2px; display: inline-block; vertical-align: middle; }"), l.push(".vd-slider-dots--type-minimal .vd-slider-dots_dot { border-radius: 50%; width: calc(6px * var(--vd-slider-dsc, 1)); margin: 0px; height: calc(6px * var(--vd-slider-dsc, 1)); }"), i ? l.push(".vd-slider-dots--type-minimal .vd-slider-dots_dot { -webkit-box-shadow: 0 0 3px 1px #bbbbbb99; -moz-box-shadow: 0 0 3px 1px #bbbbbb99; box-shadow: 0 0 3px 1px #bbbbbb99; }") : l.push(".vd-slider-dots--type-minimal .vd-slider-dots_dot { -webkit-box-shadow: none; -moz-box-shadow: none; box-shadow: none; }"), l.push(".vd-slider-dots--type-number .vd-slider-dots_dot-wrapper {  display: inline; }"), l.push(".vd-slider-dots--type-number .vd-slider-dots_dot { padding: 3px; font-size: 12px; font-weight: bold; color: " + e + "; background-color: initial; }"), l.push(".vd-slider-dots--type-number .vd-slider-dots_dot.vd-slider-dots_dot--current { color: " + s + "; background-color: initial; }"), l.push(".vd-slider-dots.vd-slider-dots--type-number .vd-slider-dots_dot-wrapper:hover .vd-slider-dots_dot { background-color: initial; color: " + s + "; }"), l.push(".vd-slider-dots--type-number .vd-slider-dots_container { padding: 6px 4px; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots--type-number .vd-slider-dots_dot-wrapper { padding: 3px 0; text-align: center; }"), l.push(".vd-slider-dots--type-counter .vd-slider-dots_dot-wrapper {  display: inline; }"), l.push(".vd-slider-dots--type-counter .vd-slider-dots_dot { display: none; padding: 3px 5px; font-size: 12px; font-weight: bold; color: " + s + "; background-color: initial; }"), l.push(".vd-slider-dots--type-counter .vd-slider-dots_dot.vd-slider-dots_dot--current { display: inline-block; background-color: initial; }"), l.push(".vd-slider-dots.vd-slider-dots--type-counter .vd-slider-dots_dot-wrapper:hover .vd-slider-dots_dot { color: " + s + "; background-color: initial; }"), l.push(".vd-slider-dots--type-counter .vd-slider-dots_container { padding: 6px 4px; }"), l.push(".vd-slider-dots--type-stretch_full .vd-slider-dots_container { width: 100%; }"), l.push(".vd-slider-dots--type-stretch_half .vd-slider-dots_container { width: 50%; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots--type-stretch_full .vd-slider-dots_container { height: 100%; width: unset; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots--type-stretch_half .vd-slider-dots_container { height: 50%; width: unset; }"), l.push(".vd-slider-dots--type-stretch_full .vd-slider-dots_container, .vd-slider-dots--type-stretch_half .vd-slider-dots_container { display: flex; padding: 0; margin: 0; }"), l.push(".vd-slider-dots--type-stretch_full .vd-slider-dots_dot-wrapper, .vd-slider-dots--type-stretch_half .vd-slider-dots_dot-wrapper { flex-grow: 1; width: 100%; padding: 6px 2px 6px 2px; }"), l.push(".vd-slider-dots--type-stretch_full .vd-slider-dots_dot-wrapper:first-of-type, .vd-slider-dots--type-stretch_half .vd-slider-dots_dot-wrapper:first-of-type { padding-left: 2px }"), l.push(".vd-slider-dots--type-stretch_full .vd-slider-dots_dot-wrapper:last-of-type, .vd-slider-dots--type-stretch_half .vd-slider-dots_dot-wrapper:last-of-type { padding-right: 2px }"), l.push(".vd-slider-dots--type-stretch_full .vd-slider-dots_dot, .vd-slider-dots--type-stretch_half .vd-slider-dots_dot { width: 100%; height: 5px; margin: 0; min-width: 3px; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots--type-stretch_full .vd-slider-dots_dot, .vd-slider-root--dl-v .vd-slider-dots--type-stretch_half .vd-slider-dots_dot { width: 5px; height: 100%; }"), l.push(".vd-slider-root--dl-v .vd-slider-dots--type-stretch_full .vd-slider-dots_dot-wrapper, .vd-slider-root--dl-v .vd-slider-dots--type-stretch_half .vd-slider-dots_dot-wrapper { padding: 2px 6px 2px 6px; }"), l.push(".vd-slider-dots--type-thumbs .vd-slider-dots_dot-wrapper { padding: 4px; display: inline-block; vertical-align: middle; }"), l.push(".vd-slider-dots--type-thumbs .vd-slider-dots_dot { position: relative; box-sizing: content-box; width: calc(50px * var(--vd-slider-dsc, 1)); height: calc(50px * var(--vd-slider-dsc, 1)); color: transparent; outline: 2px solid " + e + "; transition: opacity .2s, outline .2s; background-color: unset; overflow: hidden !important; }"), l.push(".vd-slider-dots--type-thumbs .vd-slider-dots_dot img { width: 100%; height: 100%; display: inline-block; object-fit: cover; background-size: cover; transform: scale(1.01); position: static; margin: 0; padding: 0; visibility: visible; transition: transform .3s, opacity .3s; pointer-events: none; }"), l.push("body:not([data-vd-slider-touch]) .vd-slider-dots--type-thumbs .vd-slider-dots_dot-wrapper:hover img { transform:scale(1.03); }"), l.push(".vd-slider-dots--type-thumbs .vd-slider-dots_dot.vd-slider-dots_dot--current { opacity: 1 !important; outline: 2px solid " + s + "; background-color: unset; }"), l.push(".vd-slider-dots_thumb { opacity: 0; }"), l.push(".vd-slider-dots_thumb[pmimg-loaded] { opacity: 1; }"), l.push(".vd-slider-root img[pmimg-loaded], .ppzoom img[pmimg-loaded] { background-repeat: no-repeat; background-position: center; }"), l.push(".vd-slider-dots_dot .vd-slider-button { width: 35px; opacity: 1; pointer-events: none; }"), l.push(".vd-slider-dots--type-thumbs.vd-slider-dots--size-2x .vd-slider-dots_dot { width: calc(100px * var(--vd-slider-dsc, 1)); height: calc(100px * var(--vd-slider-dsc, 1)); }"), l.push(".vd-slider-dots--type-thumbs.vd-slider-dots--adaptive .vd-slider-dots_dot { width: unset; min-width: calc(50px * var(--vd-slider-dsc, 1)); max-width: calc(150px * var(--vd-slider-dsc, 1)); height: calc(100px * var(--vd-slider-dsc, 1)); aspect-ratio: var(--pmthumb-ar); }"), l.push(".vd-slider-root--dl-v .vd-slider-dots--type-thumbs.vd-slider-dots--adaptive .vd-slider-dots_dot { width: calc(100px * var(--vd-slider-dsc, 1)); height: unset; min-height: calc(50px * var(--vd-slider-dsc, 1)); max-height: calc(150px * var(--vd-slider-dsc, 1)); aspect-ratio: var(--pmthumb-ar); }"), l.push("body:not([data-vd-slider-touch]) .vd-slider-dots--type-thumbs.vd-slider-dots--size-2x .vd-slider-dots_dot-wrapper:hover img { transform:scale(1.03); }"), l.push(n(".vd-slider-dots--type-thumbs.vd-slider-dots--adaptive .vd-slider-dots_dot { max-width: 30vw; height: 20vw; }")), l.push(n(".vd-slider-dots--type-thumbs.vd-slider-dots--size-2x .vd-slider-dots_dot { width: 20vw; height: 20vw; }")), l.push(".vd-slider-dots_dot--view-more .vd-slider-button { display: none !important; }"), l.push(".vd-slider-dots_dot--view-more-overlay { display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.6); z-index: 1; line-height: normal; font-size: 0.8em; text-align: center; }"), l.push(".vd-slider-dots_dot--view-more-overlay > :first-child { font-size: 1em; font-weight: bold; }"), t.v >= 5 ? (l.push(d(".vd-slider-mount { position: sticky; top: 1rem; }")), l.push(n(".vd-slider-root .vd-slider-dots.vd-slider-dots--flex.vd-slider-dots--type-thumbs { justify-content: flex-start; }")), l.push(".vd-slider-root.vd-slider-root--ar-fit .vd-slider-slide img { height: calc(100% + 1px); }"), l.push(".vd-slider-root.vd-slider-root--ar-fit .vd-slider-slide { height: calc(100% + 2px); max-width: calc(100% + 2px); top: -1px; left: -1px; }")) : (l.push(".vd-slider-root .vd-slider-slide img { height: 101%; }"), l.push(".vd-slider-root.vd-slider-root--ar-fit .vd-slider-slide { height: 102%; max-width: 102%; top: -1%; left: -1%; }")), t.ss || (l.push(".vd-slider-own--slides-wrapper { border-radius: 3px; }"), l.push(".vd-slider-dots--type-thumbs .vd-slider-dots_dot { border-radius: 3px; }")), l.push("body:not([data-vd-slider-touch]) .vd-slider-dots:not(.vd-slider-dots--type-thumbs):not(.vd-slider-dots--type-counter):not(.vd-slider-dots--type-number) .vd-slider-dots_dot-wrapper:hover .vd-slider-dots_dot { background-color: " + s + "; }"), l.push("body:not([data-vd-slider-touch]) .vd-slider-dots.vd-slider-dots--type-thumbs .vd-slider-dots_dot-wrapper:hover .vd-slider-dots_dot { opacity: 1; outline-color: " + s + "; }"), l.push(".vd-slider-modal { display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; z-index: 2147483641; }"), l.push(".vd-slider-modal.is-open { display: block; }"), l.push(".vd-slider-modal--dialog { height: 100%; background-color: #000000e8; display: flex; flex-direction: column; }"), l.push(".vd-slider-modal--close { position: absolute; top: 10px; right: 10px; width: 40px; height: 40px; color: white; opacity: 0.8; background-color: black; cursor: pointer; }"), l.push(".vd-slider-modal--close:hover { opacity: 1 }"), l.push(".vd-slider-modal--content { display: flex; align-items: center; flex-grow: 1; height: 100%; }"), l.push(".vd-slider-modal--content .plyr__controls { margin-bottom: 15px; }"), l.push("@media only screen and (max-aspect-ratio: 1/1) { .vd-slider-modal--content { padding-bottom: 3rem; } }"), l.push(".vd-slider-modal.vd-slider-modal--white .vd-slider-modal--dialog { background-color: white; }"), l.push(".vd-slider-modal.vd-slider-modal--white .vd-slider-modal--close { background-color: transparent; color: black; }"), l.push(".vd-slider-modal--actions { width: 100%; display: flex; justify-content: center; align-items: center; gap: 12px; padding: 12px 16px; }"), l.push(".vd-slider-modal--actions:empty { display: none; padding: 0; margin: 0; }"), l.push(".vd-slider-modal--overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: -1; background: rgba(0, 0, 0, 0.5); }"), l.push(".vd-slider-fs-ar { width: 100%; height: 100%; margin: 0 auto; }"), l.push(".vd-slider-fs-ar--content { margin: auto; max-width: 100%; height: 100%; position: relative; }"), l.push(".vd-slider-fs-ar--content > *, .vd-slider-fs-ar--content img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }"), l.push(".vd-slider-fs-ar--content img { background: black url('https://pmslider.netlify.app/etc/loader.svg') no-repeat 50%; }"), l.push(".vd-slider-center { height: 100%; display: flex; }"), l.push(".vd-slider-center > * { margin: auto; }"), l.push(".vd-slider-root:not(.vd-slider-root--zoom-click) .vd-slider-slide--hover-zoom { cursor: crosshair !important; }"), l.push(n(".vd-slider-root--hide-arrows-on-mobile .vd-slider-own--slides-wrapper .vd-slider-arrows { display: none !important; }")), l.push(".vd-slider-root { opacity: 1; transition: opacity 0.2s; z-index: 1; }"), l.push(".vd-slider-root + .vd-slider-root { position: absolute; opacity: 0 !important; top: 0; z-index: -1; }"), l.push(".vd-slider-root + .vd-slider-root * { pointer-events: none !important; }"), l.push(".vd-slider-own--actions { display: flex; gap: 10px; padding: 10px; pointer-events: all; position: absolute; top: 0; left: 0; z-index: 3; }"), l.push(".vd-slider--gallery-action-bar { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; }"), l.push(".vd-slider--gallery-action { cursor: pointer; padding: 4px 13px 4px 9px; border-radius: 20px; opacity: 0.8; box-shadow: 0px 0px 10px -5px #000000; display: inline-block; background-color: " + o + "; color: " + r + ";}"), l.push(".vd-slider--gallery-action:hover { opacity: 1; }"), t.zbgw && (l.push(".ppzoom__bg, .ppzoom__img--placeholder--blank { background: white !important; }"), l.push(".ppzoom--svg .ppzoom__button, .ppzoom--svg .ppzoom__button--arrow--left:before, .ppzoom--svg .ppzoom__button--arrow--right:before { background-image: url(https://pmslider.netlify.app/etc/zoom-skin-black.svg) !important; background-color: white !important; }"), l.push(".ppzoom__top-bar, .ppzoom__caption { background: white !important; }"), l.push(".ppzoom__counter { color: black !important; }"), l.push(".ppzoom__button.ppzoom__button--arrow--right, .ppzoom__button.ppzoom__button--arrow--left { background: transparent !important }")), l.push(".vd-slider-slide--hover-zoom { display: block !important; background-color: transparent; background-repeat: no-repeat; position: absolute; left: 0; top: 0; right: 0; bottom: 0; width: 100%; height: 100%; z-index: 2; box-shadow: 0px 0px 20px -5px #0000007d; }"), l.push(".vd-slider-hover-zoom-side { position: absolute; opacity: 0; pointer-events: none; width: 0; height: 0; transition: opacity 0.15s ease; margin-left: 10px; }"), l.push(".vd-slider-hover-zoom-side[data-visible='true'] { opacity: 1; }"), l.push(".vd-slider-hover-zoom-lens { z-index: 10; position: absolute; top: 0; left: 0; border: 2px solid rgba(255, 255, 255, 0.85); background-color: rgba(255, 255, 255, 0.2); box-shadow: 0 0 12px rgba(0, 0, 0, 0.25); pointer-events: none; transform: translate3d(0, 0, 0); }"), l.push("body.vd-slider-modal-open { overflow: hidden; }"), l.push(".vd-slider-mount { width: 100%; }"), l.push(".vd-slider-model-viewer, .vd-slider-model-viewer model-viewer { width: 100%; height: 100%; }"), l.push(".vd-slider-model-viewer { cursor: pointer; }"), l.push(".vd-slider-button { width: 60px; transition: transform 0.5s; aspect-ratio: 1; display: block !important; box-shadow: 0px 0px 10px 0px #0e0e0e5e; border-radius: 50%; position: absolute; top: 50%; right: 50%; cursor: pointer; background: #0000008c; color: white; overflow: hidden; z-index: 1; transform: translate(50%, -50%) scale(1.01); opacity: 0.8; }"), l.push(".vd-slider-button:hover { opacity: 1; }"), l.push(".vd-slider-button svg { width: 100%; height: 100%; display: block; padding: 15%; stroke: currentColor; box-sizing: border-box; }"), l.push(".vd-slider-button-with-text { display: flex; align-items: center; gap: 5px; font-size: 0.9em; }"), l.push(".vd-slider-button-with-text > * { display: flex; }"), l.push(".vd-slider-slide--inner:hover .vd-slider-button { transform: translate(50%, -50%) scale(1.1); }"), l = U(t, l), t.tc && (l = U(t.tc, l)), window.vdSliderLoadedStyles && document.head.removeChild(window.vdSliderLoadedStyles), window.vdSliderLoadedStyles = document.createElement("style"), window.vdSliderLoadedStyles.appendChild(document.createTextNode(l.join("\n"))), document.head.appendChild(window.vdSliderLoadedStyles), window.dispatchEvent(new Event("resize"))
                }(s), ot(), t.Li(i), e(window, "vd-slider-mount-new", (function() {
                    t.Li(i)
                })), e(document, "DOMContentLoaded", (function(s) {
                    t.Li(i), ot()
                })), e(window, "load", s => {
                    t.Li(i)
                }), e(window, "locationchange", (function() {
                    s.i_e_olc ? s.i_e_olc(t, i) : t.Ze(i)
                })), s.i_e_robc) {
                var r = window.matchMedia("(min-width: " + (s.i_mb || 800) + "px)");
                e(r, "change", (function() {
                    var s = document.querySelector(".vd-slider-root");
                    s && s.parentNode && s.parentNode.removeChild(s), t.Li(i)
                }))
            }
            window.vdSliderTT || (window.vdSliderTT = function() {
                if (document.body) {
                    var t = function() {
                        window.vdSliderTouchDetected = !0, document.body.setAttribute("data-vd-slider-touch", !0), document.body.removeEventListener("touchstart", t)
                    };
                    document.body.addEventListener("touchstart", t)
                }
            }, window.addEventListener("DOMContentLoaded", window.vdSliderTT), window.vdSliderTT())
        }

        function nt() {
            if (!window.vdSliderInitialized) {
                window.vdSliderInitialized = !0;
                var t = st();
                if (t.cbp) var i = t.cbp(t);
                else i = function(t) {
                    var i = window.location.href.split("?")[0].split("#")[0].split("/").pop();
                    return !(t.rti && !window.vdSliderProductPreload && !window.vdSliderIrti) && new J(window.vdSliderProductPreload, i, t)
                }(t);
                i && i.cr((function() {
                    (t.tc || tt(t), function(t, i) {
                        if (t.i_e_sp && t.i_e_sp(i)) return !0;
                        let s = t.i_mb || 800;
                        if (t.hom && window.innerWidth < s) return !0;
                        if (t.hod && window.innerWidth > s) return !0
                    }(t, i)) ? window.vdSliderInitialized = !1: function(t) {
                        let i = t.Ee();
                        if (!i) return !1;
                        if (0 === t.De(i).Ie.length) return !1;
                        return !0
                    }(i) && (i.ur("gg-slider-disable") || dt(G(t), i, t))
                }))
            }
        }
        t((function() {
            e(window, "vd-slider-engine", (function() {
                nt()
            })), e(window, "resize", function(t, i) {
                let s;
                return function(...e) {
                    clearTimeout(s), s = r(() => t.apply(this, e), i)
                }
            }((function() {
                nt()
            }), 500)), nt()
        }))
    }();
}